/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SsoRouteImport } from './routes/sso'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as PrintRouteImport } from './routes/_print'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthProfileRouteImport } from './routes/_auth/profile'
import { Route as AuthUsersIndexRouteImport } from './routes/_auth/users/index'
import { Route as AuthAttendanceIndexRouteImport } from './routes/_auth/attendance/index'
import { Route as AuthUsersViewRouteImport } from './routes/_auth/users/view'
import { Route as AuthUsersSpecialRouteImport } from './routes/_auth/users/special'
import { Route as AuthUsersRolesRouteImport } from './routes/_auth/users/roles'
import { Route as AuthUsersPermissionsRouteImport } from './routes/_auth/users/permissions'
import { Route as AuthUsersMarketingRouteImport } from './routes/_auth/users/marketing'
import { Route as AuthUsersGeneralRouteImport } from './routes/_auth/users/general'
import { Route as AuthUsersEditRouteImport } from './routes/_auth/users/edit'
import { Route as AuthUsersAgentRouteImport } from './routes/_auth/users/agent'
import { Route as AuthUsersAdminRouteImport } from './routes/_auth/users/admin'
import { Route as AuthSettingsWebUrlsRouteImport } from './routes/_auth/settings/web-urls'
import { Route as AuthSettingsMenuLabelsRouteImport } from './routes/_auth/settings/menu-labels'
import { Route as AuthSettingsLimitTypesRouteImport } from './routes/_auth/settings/limit-types'
import { Route as AuthSettingsLeaveTypesRouteImport } from './routes/_auth/settings/leave-types'
import { Route as AuthSettingsInstituteTypesRouteImport } from './routes/_auth/settings/institute-types'
import { Route as AuthSettingsHolidaysRouteImport } from './routes/_auth/settings/holidays'
import { Route as AuthSettingsFeedbackTypesRouteImport } from './routes/_auth/settings/feedback-types'
import { Route as AuthReportsAppVersionCheckRouteImport } from './routes/_auth/reports/app-version-check'
import { Route as AuthQuestionUploadRouteImport } from './routes/_auth/question/upload'
import { Route as AuthQuestionSubjectsRouteImport } from './routes/_auth/question/subjects'
import { Route as AuthQuestionProjectsRouteImport } from './routes/_auth/question/projects'
import { Route as AuthQuestionDownloadByClassRouteImport } from './routes/_auth/question/download-by-class'
import { Route as AuthQuestionDownloadByBoardRouteImport } from './routes/_auth/question/download-by-board'
import { Route as AuthQuestionDownloadRouteImport } from './routes/_auth/question/download'
import { Route as AuthPublishSalesRouteImport } from './routes/_auth/publish/sales'
import { Route as AuthPublishMisRouteImport } from './routes/_auth/publish/mis'
import { Route as AuthPublishAccountsRouteImport } from './routes/_auth/publish/accounts'
import { Route as AuthPromotionItemsRouteImport } from './routes/_auth/promotion/items'
import { Route as AuthPromotionItemTypesRouteImport } from './routes/_auth/promotion/item-types'
import { Route as AuthPromotionDistributionRouteImport } from './routes/_auth/promotion/distribution'
import { Route as AuthProductSpecimensRouteImport } from './routes/_auth/product/specimens'
import { Route as AuthProductSpecimenRequisitionReviewRouteImport } from './routes/_auth/product/specimen-requisition-review'
import { Route as AuthProductSpecimenRequisitionRouteImport } from './routes/_auth/product/specimen-requisition'
import { Route as AuthProductSpecimenListViewRouteImport } from './routes/_auth/product/specimen-list-view'
import { Route as AuthProductSpecimenInstitutionRouteImport } from './routes/_auth/product/specimen-institution'
import { Route as AuthProductSpecimenAdjustmentRouteImport } from './routes/_auth/product/specimen-adjustment'
import { Route as AuthProductSpPromotionalRequisitionRouteImport } from './routes/_auth/product/sp-promotional-requisition'
import { Route as AuthProductDcrSheetRouteImport } from './routes/_auth/product/dcr-sheet'
import { Route as AuthProductDcrDateToDateRouteImport } from './routes/_auth/product/dcr-date-to-date'
import { Route as AuthProductBookTypesRouteImport } from './routes/_auth/product/book-types'
import { Route as AuthProductBookEditionsRouteImport } from './routes/_auth/product/book-editions'
import { Route as AuthMarketPromotionRequisitionsRouteImport } from './routes/_auth/market-promotion/requisitions'
import { Route as AuthMarketPromotionProjectsRouteImport } from './routes/_auth/market-promotion/projects'
import { Route as AuthMarketPromotionMisApprovalsRouteImport } from './routes/_auth/market-promotion/mis-approvals'
import { Route as AuthMarketPromotionDistributionSummaryRouteImport } from './routes/_auth/market-promotion/distribution-summary'
import { Route as AuthMarketPromotionCashCollectionRouteImport } from './routes/_auth/market-promotion/cash-collection'
import { Route as AuthMarketPromotionBudgetEntryRouteImport } from './routes/_auth/market-promotion/budget-entry'
import { Route as AuthMarketPromotionApprovalReportRouteImport } from './routes/_auth/market-promotion/approval-report'
import { Route as AuthMarketPromotionAccountsAdjustRouteImport } from './routes/_auth/market-promotion/accounts-adjust'
import { Route as AuthHrFormLeaveReportRouteImport } from './routes/_auth/hr-form/leave-report'
import { Route as AuthFeedbackTypesRouteImport } from './routes/_auth/feedback/types'
import { Route as AuthDashboardsPendingRouteImport } from './routes/_auth/dashboards/pending'
import { Route as AuthDashboardsDerRouteImport } from './routes/_auth/dashboards/der'
import { Route as AuthBillingWebExpenseRouteImport } from './routes/_auth/billing/web-expense'
import { Route as AuthBillingOfflineDerVerifyRouteImport } from './routes/_auth/billing/offline-der-verify'
import { Route as AuthBillingOfflineDcrVerifyRouteImport } from './routes/_auth/billing/offline-dcr-verify'
import { Route as AuthBillingExpenseApproveRouteImport } from './routes/_auth/billing/expense-approve'
import { Route as AuthBillingDcrApproveRouteImport } from './routes/_auth/billing/dcr-approve'
import { Route as AuthBillingCostAmendmentRouteImport } from './routes/_auth/billing/cost-amendment'
import { Route as AuthBillingApprovalRouteImport } from './routes/_auth/billing/approval'
import { Route as AuthBillingAllCostRouteImport } from './routes/_auth/billing/all-cost'
import { Route as AuthAttendanceShiftJobCardRouteImport } from './routes/_auth/attendance/shift-job-card'
import { Route as AuthAttendanceShiftEmployeeReportRouteImport } from './routes/_auth/attendance/shift-employee-report'
import { Route as AuthAttendanceJobCardRouteImport } from './routes/_auth/attendance/job-card'
import { Route as AuthAttendanceEmployeeReportRouteImport } from './routes/_auth/attendance/employee-report'
import { Route as AuthSettingsTeacherSubmissionsIndexRouteImport } from './routes/_auth/settings/teacher-submissions/index'
import { Route as AuthSettingsTeacherInactivationsIndexRouteImport } from './routes/_auth/settings/teacher-inactivations/index'
import { Route as AuthSettingsInstitutesIndexRouteImport } from './routes/_auth/settings/institutes/index'
import { Route as AuthSettingsInstituteSubmissionsIndexRouteImport } from './routes/_auth/settings/institute-submissions/index'
import { Route as AuthPromotionAdjustmentIndexRouteImport } from './routes/_auth/promotion/adjustment/index'
import { Route as AuthProductStudentCollectionProjectsIndexRouteImport } from './routes/_auth/product/student-collection-projects/index'
import { Route as AuthProductSpecimenDistributionIndexRouteImport } from './routes/_auth/product/specimen-distribution/index'
import { Route as AuthProductBooklistedInstitutionIndexRouteImport } from './routes/_auth/product/booklisted-institution/index'
import { Route as AuthPcmpRequestsIndexRouteImport } from './routes/_auth/pcmp/requests/index'
import { Route as AuthPcmpRequestCategoriesIndexRouteImport } from './routes/_auth/pcmp/request-categories/index'
import { Route as AuthPcmpProjectsIndexRouteImport } from './routes/_auth/pcmp/projects/index'
import { Route as AuthPcmpMisIndexRouteImport } from './routes/_auth/pcmp/mis/index'
import { Route as AuthPcmpMarketingIndexRouteImport } from './routes/_auth/pcmp/marketing/index'
import { Route as AuthPcmpEditPermissionsIndexRouteImport } from './routes/_auth/pcmp/edit-permissions/index'
import { Route as AuthPcmpDisburseVerifyIndexRouteImport } from './routes/_auth/pcmp/disburse-verify/index'
import { Route as AuthPcmpDepartmentDivisionsIndexRouteImport } from './routes/_auth/pcmp/department-divisions/index'
import { Route as AuthPcmpCorrectionIndexRouteImport } from './routes/_auth/pcmp/correction/index'
import { Route as AuthPcmpAccountsIndexRouteImport } from './routes/_auth/pcmp/accounts/index'
import { Route as AuthMarketPromotionRegionSummaryIndexRouteImport } from './routes/_auth/market-promotion/region-summary/index'
import { Route as AuthMarketPromotionPublishPanelIndexRouteImport } from './routes/_auth/market-promotion/publish-panel/index'
import { Route as AuthMarketPromotionApprovalsIndexRouteImport } from './routes/_auth/market-promotion/approvals/index'
import { Route as AuthMarketPromotionAdjustmentIndexRouteImport } from './routes/_auth/market-promotion/adjustment/index'
import { Route as AuthHrFormLeaveApplicationsIndexRouteImport } from './routes/_auth/hr-form/leave-applications/index'
import { Route as AuthGeoLocationMoTravelHistoryIndexRouteImport } from './routes/_auth/geo-location/mo-travel-history/index'
import { Route as AuthFeedbackSurveysIndexRouteImport } from './routes/_auth/feedback/surveys/index'
import { Route as AuthFeedbackListIndexRouteImport } from './routes/_auth/feedback/list/index'
import { Route as AuthDashboardsZonalStatementIndexRouteImport } from './routes/_auth/dashboards/zonal-statement/index'
import { Route as AuthDashboardsSystemIndexRouteImport } from './routes/_auth/dashboards/system/index'
import { Route as AuthDashboardsDcrIndexRouteImport } from './routes/_auth/dashboards/dcr/index'
import { Route as AuthUsersCreateCategoryRouteImport } from './routes/_auth/users/create.$category'
import { Route as AuthSettingsTeacherSubmissionsTeacherIdRouteImport } from './routes/_auth/settings/teacher-submissions/$teacherId'
import { Route as AuthSettingsTeacherInactivationsRequestIdRouteImport } from './routes/_auth/settings/teacher-inactivations/$requestId'
import { Route as AuthSettingsInstitutesUserMappingRouteImport } from './routes/_auth/settings/institutes/user-mapping'
import { Route as AuthSettingsInstitutesCreateRouteImport } from './routes/_auth/settings/institutes/create'
import { Route as AuthSettingsInstituteSubmissionsSubmissionIdRouteImport } from './routes/_auth/settings/institute-submissions/$submissionId'
import { Route as AuthQuestionPapersProjectInstituteIdRouteImport } from './routes/_auth/question/papers/$projectInstituteId'
import { Route as AuthQuestionMonitorDistrictsRouteImport } from './routes/_auth/question/monitor/districts'
import { Route as AuthQuestionMonitorClassesRouteImport } from './routes/_auth/question/monitor/classes'
import { Route as AuthPublishBatchesBatchIdRouteImport } from './routes/_auth/publish/batches/$batchId'
import { Route as AuthProductStudentCollectionProjectsProjectIdRouteImport } from './routes/_auth/product/student-collection-projects/$projectId'
import { Route as AuthProductBooklistedInstitutionProjectIdRouteImport } from './routes/_auth/product/booklisted-institution/$projectId'
import { Route as AuthPcmpProjectsNewRouteImport } from './routes/_auth/pcmp/projects/new'
import { Route as AuthMarketPromotionRegionSummaryDonationsRouteImport } from './routes/_auth/market-promotion/region-summary/donations'
import { Route as AuthMarketPromotionPublishPanelNewRouteImport } from './routes/_auth/market-promotion/publish-panel/new'
import { Route as AuthMarketPromotionApprovalsDetailIdRouteImport } from './routes/_auth/market-promotion/approvals/$detailId'
import { Route as AuthHrFormLeaveApplicationsApplicationIdRouteImport } from './routes/_auth/hr-form/leave-applications/$applicationId'
import { Route as AuthGeoLocationMoTravelHistoryUserIdRouteImport } from './routes/_auth/geo-location/mo-travel-history/$userId'
import { Route as AuthFeedbackSurveysNewRouteImport } from './routes/_auth/feedback/surveys/new'
import { Route as AuthFeedbackListFeedbackIdRouteImport } from './routes/_auth/feedback/list/$feedbackId'
import { Route as AuthDashboardsSystemUserIdRouteImport } from './routes/_auth/dashboards/system/$userId'
import { Route as AuthDashboardsDcrUserIdRouteImport } from './routes/_auth/dashboards/dcr/$userId'
import { Route as AuthQuestionMonitorInstitutesIndexRouteImport } from './routes/_auth/question/monitor/institutes/index'
import { Route as AuthPromotionAdjustmentPromoItemIdIndexRouteImport } from './routes/_auth/promotion/adjustment/$promoItemId/index'
import { Route as AuthProductSpecimenDistributionSpecimenIdIndexRouteImport } from './routes/_auth/product/specimen-distribution/$specimenId/index'
import { Route as AuthPcmpRequestsRequestedIndexRouteImport } from './routes/_auth/pcmp/requests/requested/index'
import { Route as AuthPcmpReportsPerformanceIndexRouteImport } from './routes/_auth/pcmp/reports/performance/index'
import { Route as AuthPcmpReportsPendingIndexRouteImport } from './routes/_auth/pcmp/reports/pending/index'
import { Route as AuthPcmpReportsMoWiseIndexRouteImport } from './routes/_auth/pcmp/reports/mo-wise/index'
import { Route as AuthPcmpReportsMisStatusIndexRouteImport } from './routes/_auth/pcmp/reports/mis-status/index'
import { Route as AuthPcmpProposalsProposalIdIndexRouteImport } from './routes/_auth/pcmp/proposals/$proposalId/index'
import { Route as AuthPcmpProjectsProjectIdIndexRouteImport } from './routes/_auth/pcmp/projects/$projectId/index'
import { Route as AuthMarketPromotionAdjustmentPromoItemIdIndexRouteImport } from './routes/_auth/market-promotion/adjustment/$promoItemId/index'
import { Route as AuthFeedbackSurveysSurveyIdIndexRouteImport } from './routes/_auth/feedback/surveys/$surveyId/index'
import { Route as PrintPcmpReportsPerformancePrintRouteImport } from './routes/_print/pcmp/reports/performance/print'
import { Route as PrintPcmpReportsPendingPrintRouteImport } from './routes/_print/pcmp/reports/pending/print'
import { Route as PrintPcmpReportsMoWisePrintRouteImport } from './routes/_print/pcmp/reports/mo-wise/print'
import { Route as PrintPcmpReportsMisStatusPrintRouteImport } from './routes/_print/pcmp/reports/mis-status/print'
import { Route as PrintPcmpProposalsProposalIdPrintRouteImport } from './routes/_print/pcmp/proposals/$proposalId/print'
import { Route as AuthSettingsInstitutesInstituteIdEditRouteImport } from './routes/_auth/settings/institutes/$instituteId/edit'
import { Route as AuthQuestionMonitorInstitutesProjectInstituteIdRouteImport } from './routes/_auth/question/monitor/institutes/$projectInstituteId'
import { Route as AuthPromotionAdjustmentPromoItemIdZmIdRouteImport } from './routes/_auth/promotion/adjustment/$promoItemId/$zmId'
import { Route as AuthProductSpecimenDistributionSpecimenIdZmIdRouteImport } from './routes/_auth/product/specimen-distribution/$specimenId/$zmId'
import { Route as AuthPcmpProjectsProjectIdEditRouteImport } from './routes/_auth/pcmp/projects/$projectId/edit'
import { Route as AuthPcmpProjectsProjectIdCreatedRouteImport } from './routes/_auth/pcmp/projects/$projectId/created'
import { Route as AuthMarketPromotionPublishPanelZonalManagersUserIdRouteImport } from './routes/_auth/market-promotion/publish-panel/zonal-managers.$userId'
import { Route as AuthMarketPromotionPublishPanelBatchesBatchIdRouteImport } from './routes/_auth/market-promotion/publish-panel/batches.$batchId'
import { Route as AuthMarketPromotionAdjustmentPromoItemIdZmIdRouteImport } from './routes/_auth/market-promotion/adjustment/$promoItemId/$zmId'
import { Route as AuthFeedbackSurveysSurveyIdEditRouteImport } from './routes/_auth/feedback/surveys/$surveyId/edit'
import { Route as AuthDashboardsZonalStatementUserIdSpecimenRouteImport } from './routes/_auth/dashboards/zonal-statement/$userId/specimen'
import { Route as AuthDashboardsZonalStatementUserIdExpenseRouteImport } from './routes/_auth/dashboards/zonal-statement/$userId/expense'
import { Route as AuthPcmpRequestsBatchesBatchNoIndexRouteImport } from './routes/_auth/pcmp/requests/batches/$batchNo/index'
import { Route as AuthPcmpMisBatchesBatchNoIndexRouteImport } from './routes/_auth/pcmp/mis/batches/$batchNo/index'
import { Route as AuthPcmpMarketingBatchesBatchNoIndexRouteImport } from './routes/_auth/pcmp/marketing/batches/$batchNo/index'
import { Route as AuthPcmpAccountsRedisburseBatchesBatchNoIndexRouteImport } from './routes/_auth/pcmp/accounts/redisburse-batches/$batchNo/index'
import { Route as AuthPcmpAccountsBatchesBatchNoIndexRouteImport } from './routes/_auth/pcmp/accounts/batches/$batchNo/index'
import { Route as AuthFeedbackSurveysSurveyIdSubmissionsIndexRouteImport } from './routes/_auth/feedback/surveys/$surveyId/submissions/index'
import { Route as PrintPcmpRequestsBatchesBatchNoPrintRouteImport } from './routes/_print/pcmp/requests/batches/$batchNo/print'
import { Route as PrintPcmpMisBatchesBatchNoPrintRouteImport } from './routes/_print/pcmp/mis/batches/$batchNo/print'
import { Route as PrintPcmpAccountsRedisburseBatchesBatchNoPrintRouteImport } from './routes/_print/pcmp/accounts/redisburse-batches/$batchNo/print'
import { Route as PrintPcmpAccountsBatchesBatchNoPrintRouteImport } from './routes/_print/pcmp/accounts/batches/$batchNo/print'
import { Route as AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRouteImport } from './routes/_auth/feedback/surveys/$surveyId/submissions/$submissionId'

const SsoRoute = SsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrintRoute = PrintRouteImport.update({
  id: '/_print',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const AuthProfileRoute = AuthProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersIndexRoute = AuthUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAttendanceIndexRoute = AuthAttendanceIndexRouteImport.update({
  id: '/attendance/',
  path: '/attendance/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersViewRoute = AuthUsersViewRouteImport.update({
  id: '/users/view',
  path: '/users/view',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersSpecialRoute = AuthUsersSpecialRouteImport.update({
  id: '/users/special',
  path: '/users/special',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersRolesRoute = AuthUsersRolesRouteImport.update({
  id: '/users/roles',
  path: '/users/roles',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersPermissionsRoute = AuthUsersPermissionsRouteImport.update({
  id: '/users/permissions',
  path: '/users/permissions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersMarketingRoute = AuthUsersMarketingRouteImport.update({
  id: '/users/marketing',
  path: '/users/marketing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersGeneralRoute = AuthUsersGeneralRouteImport.update({
  id: '/users/general',
  path: '/users/general',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersEditRoute = AuthUsersEditRouteImport.update({
  id: '/users/edit',
  path: '/users/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersAgentRoute = AuthUsersAgentRouteImport.update({
  id: '/users/agent',
  path: '/users/agent',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersAdminRoute = AuthUsersAdminRouteImport.update({
  id: '/users/admin',
  path: '/users/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsWebUrlsRoute = AuthSettingsWebUrlsRouteImport.update({
  id: '/settings/web-urls',
  path: '/settings/web-urls',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsMenuLabelsRoute = AuthSettingsMenuLabelsRouteImport.update({
  id: '/settings/menu-labels',
  path: '/settings/menu-labels',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsLimitTypesRoute = AuthSettingsLimitTypesRouteImport.update({
  id: '/settings/limit-types',
  path: '/settings/limit-types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsLeaveTypesRoute = AuthSettingsLeaveTypesRouteImport.update({
  id: '/settings/leave-types',
  path: '/settings/leave-types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsInstituteTypesRoute =
  AuthSettingsInstituteTypesRouteImport.update({
    id: '/settings/institute-types',
    path: '/settings/institute-types',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsHolidaysRoute = AuthSettingsHolidaysRouteImport.update({
  id: '/settings/holidays',
  path: '/settings/holidays',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsFeedbackTypesRoute =
  AuthSettingsFeedbackTypesRouteImport.update({
    id: '/settings/feedback-types',
    path: '/settings/feedback-types',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsAppVersionCheckRoute =
  AuthReportsAppVersionCheckRouteImport.update({
    id: '/reports/app-version-check',
    path: '/reports/app-version-check',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionUploadRoute = AuthQuestionUploadRouteImport.update({
  id: '/question/upload',
  path: '/question/upload',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQuestionSubjectsRoute = AuthQuestionSubjectsRouteImport.update({
  id: '/question/subjects',
  path: '/question/subjects',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQuestionProjectsRoute = AuthQuestionProjectsRouteImport.update({
  id: '/question/projects',
  path: '/question/projects',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQuestionDownloadByClassRoute =
  AuthQuestionDownloadByClassRouteImport.update({
    id: '/question/download-by-class',
    path: '/question/download-by-class',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionDownloadByBoardRoute =
  AuthQuestionDownloadByBoardRouteImport.update({
    id: '/question/download-by-board',
    path: '/question/download-by-board',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionDownloadRoute = AuthQuestionDownloadRouteImport.update({
  id: '/question/download',
  path: '/question/download',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPublishSalesRoute = AuthPublishSalesRouteImport.update({
  id: '/publish/sales',
  path: '/publish/sales',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPublishMisRoute = AuthPublishMisRouteImport.update({
  id: '/publish/mis',
  path: '/publish/mis',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPublishAccountsRoute = AuthPublishAccountsRouteImport.update({
  id: '/publish/accounts',
  path: '/publish/accounts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPromotionItemsRoute = AuthPromotionItemsRouteImport.update({
  id: '/promotion/items',
  path: '/promotion/items',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPromotionItemTypesRoute = AuthPromotionItemTypesRouteImport.update({
  id: '/promotion/item-types',
  path: '/promotion/item-types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPromotionDistributionRoute =
  AuthPromotionDistributionRouteImport.update({
    id: '/promotion/distribution',
    path: '/promotion/distribution',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimensRoute = AuthProductSpecimensRouteImport.update({
  id: '/product/specimens',
  path: '/product/specimens',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProductSpecimenRequisitionReviewRoute =
  AuthProductSpecimenRequisitionReviewRouteImport.update({
    id: '/product/specimen-requisition-review',
    path: '/product/specimen-requisition-review',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenRequisitionRoute =
  AuthProductSpecimenRequisitionRouteImport.update({
    id: '/product/specimen-requisition',
    path: '/product/specimen-requisition',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenListViewRoute =
  AuthProductSpecimenListViewRouteImport.update({
    id: '/product/specimen-list-view',
    path: '/product/specimen-list-view',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenInstitutionRoute =
  AuthProductSpecimenInstitutionRouteImport.update({
    id: '/product/specimen-institution',
    path: '/product/specimen-institution',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenAdjustmentRoute =
  AuthProductSpecimenAdjustmentRouteImport.update({
    id: '/product/specimen-adjustment',
    path: '/product/specimen-adjustment',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpPromotionalRequisitionRoute =
  AuthProductSpPromotionalRequisitionRouteImport.update({
    id: '/product/sp-promotional-requisition',
    path: '/product/sp-promotional-requisition',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductDcrSheetRoute = AuthProductDcrSheetRouteImport.update({
  id: '/product/dcr-sheet',
  path: '/product/dcr-sheet',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProductDcrDateToDateRoute =
  AuthProductDcrDateToDateRouteImport.update({
    id: '/product/dcr-date-to-date',
    path: '/product/dcr-date-to-date',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductBookTypesRoute = AuthProductBookTypesRouteImport.update({
  id: '/product/book-types',
  path: '/product/book-types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProductBookEditionsRoute = AuthProductBookEditionsRouteImport.update({
  id: '/product/book-editions',
  path: '/product/book-editions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMarketPromotionRequisitionsRoute =
  AuthMarketPromotionRequisitionsRouteImport.update({
    id: '/market-promotion/requisitions',
    path: '/market-promotion/requisitions',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionProjectsRoute =
  AuthMarketPromotionProjectsRouteImport.update({
    id: '/market-promotion/projects',
    path: '/market-promotion/projects',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionMisApprovalsRoute =
  AuthMarketPromotionMisApprovalsRouteImport.update({
    id: '/market-promotion/mis-approvals',
    path: '/market-promotion/mis-approvals',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionDistributionSummaryRoute =
  AuthMarketPromotionDistributionSummaryRouteImport.update({
    id: '/market-promotion/distribution-summary',
    path: '/market-promotion/distribution-summary',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionCashCollectionRoute =
  AuthMarketPromotionCashCollectionRouteImport.update({
    id: '/market-promotion/cash-collection',
    path: '/market-promotion/cash-collection',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionBudgetEntryRoute =
  AuthMarketPromotionBudgetEntryRouteImport.update({
    id: '/market-promotion/budget-entry',
    path: '/market-promotion/budget-entry',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionApprovalReportRoute =
  AuthMarketPromotionApprovalReportRouteImport.update({
    id: '/market-promotion/approval-report',
    path: '/market-promotion/approval-report',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionAccountsAdjustRoute =
  AuthMarketPromotionAccountsAdjustRouteImport.update({
    id: '/market-promotion/accounts-adjust',
    path: '/market-promotion/accounts-adjust',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthHrFormLeaveReportRoute = AuthHrFormLeaveReportRouteImport.update({
  id: '/hr-form/leave-report',
  path: '/hr-form/leave-report',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeedbackTypesRoute = AuthFeedbackTypesRouteImport.update({
  id: '/feedback/types',
  path: '/feedback/types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardsPendingRoute = AuthDashboardsPendingRouteImport.update({
  id: '/dashboards/pending',
  path: '/dashboards/pending',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardsDerRoute = AuthDashboardsDerRouteImport.update({
  id: '/dashboards/der',
  path: '/dashboards/der',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingWebExpenseRoute = AuthBillingWebExpenseRouteImport.update({
  id: '/billing/web-expense',
  path: '/billing/web-expense',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingOfflineDerVerifyRoute =
  AuthBillingOfflineDerVerifyRouteImport.update({
    id: '/billing/offline-der-verify',
    path: '/billing/offline-der-verify',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBillingOfflineDcrVerifyRoute =
  AuthBillingOfflineDcrVerifyRouteImport.update({
    id: '/billing/offline-dcr-verify',
    path: '/billing/offline-dcr-verify',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBillingExpenseApproveRoute =
  AuthBillingExpenseApproveRouteImport.update({
    id: '/billing/expense-approve',
    path: '/billing/expense-approve',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBillingDcrApproveRoute = AuthBillingDcrApproveRouteImport.update({
  id: '/billing/dcr-approve',
  path: '/billing/dcr-approve',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingCostAmendmentRoute =
  AuthBillingCostAmendmentRouteImport.update({
    id: '/billing/cost-amendment',
    path: '/billing/cost-amendment',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBillingApprovalRoute = AuthBillingApprovalRouteImport.update({
  id: '/billing/approval',
  path: '/billing/approval',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingAllCostRoute = AuthBillingAllCostRouteImport.update({
  id: '/billing/all-cost',
  path: '/billing/all-cost',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAttendanceShiftJobCardRoute =
  AuthAttendanceShiftJobCardRouteImport.update({
    id: '/attendance/shift-job-card',
    path: '/attendance/shift-job-card',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAttendanceShiftEmployeeReportRoute =
  AuthAttendanceShiftEmployeeReportRouteImport.update({
    id: '/attendance/shift-employee-report',
    path: '/attendance/shift-employee-report',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAttendanceJobCardRoute = AuthAttendanceJobCardRouteImport.update({
  id: '/attendance/job-card',
  path: '/attendance/job-card',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAttendanceEmployeeReportRoute =
  AuthAttendanceEmployeeReportRouteImport.update({
    id: '/attendance/employee-report',
    path: '/attendance/employee-report',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsTeacherSubmissionsIndexRoute =
  AuthSettingsTeacherSubmissionsIndexRouteImport.update({
    id: '/settings/teacher-submissions/',
    path: '/settings/teacher-submissions/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsTeacherInactivationsIndexRoute =
  AuthSettingsTeacherInactivationsIndexRouteImport.update({
    id: '/settings/teacher-inactivations/',
    path: '/settings/teacher-inactivations/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstitutesIndexRoute =
  AuthSettingsInstitutesIndexRouteImport.update({
    id: '/settings/institutes/',
    path: '/settings/institutes/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstituteSubmissionsIndexRoute =
  AuthSettingsInstituteSubmissionsIndexRouteImport.update({
    id: '/settings/institute-submissions/',
    path: '/settings/institute-submissions/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPromotionAdjustmentIndexRoute =
  AuthPromotionAdjustmentIndexRouteImport.update({
    id: '/promotion/adjustment/',
    path: '/promotion/adjustment/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductStudentCollectionProjectsIndexRoute =
  AuthProductStudentCollectionProjectsIndexRouteImport.update({
    id: '/product/student-collection-projects/',
    path: '/product/student-collection-projects/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenDistributionIndexRoute =
  AuthProductSpecimenDistributionIndexRouteImport.update({
    id: '/product/specimen-distribution/',
    path: '/product/specimen-distribution/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductBooklistedInstitutionIndexRoute =
  AuthProductBooklistedInstitutionIndexRouteImport.update({
    id: '/product/booklisted-institution/',
    path: '/product/booklisted-institution/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpRequestsIndexRoute = AuthPcmpRequestsIndexRouteImport.update({
  id: '/pcmp/requests/',
  path: '/pcmp/requests/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPcmpRequestCategoriesIndexRoute =
  AuthPcmpRequestCategoriesIndexRouteImport.update({
    id: '/pcmp/request-categories/',
    path: '/pcmp/request-categories/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpProjectsIndexRoute = AuthPcmpProjectsIndexRouteImport.update({
  id: '/pcmp/projects/',
  path: '/pcmp/projects/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPcmpMisIndexRoute = AuthPcmpMisIndexRouteImport.update({
  id: '/pcmp/mis/',
  path: '/pcmp/mis/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPcmpMarketingIndexRoute = AuthPcmpMarketingIndexRouteImport.update({
  id: '/pcmp/marketing/',
  path: '/pcmp/marketing/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPcmpEditPermissionsIndexRoute =
  AuthPcmpEditPermissionsIndexRouteImport.update({
    id: '/pcmp/edit-permissions/',
    path: '/pcmp/edit-permissions/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpDisburseVerifyIndexRoute =
  AuthPcmpDisburseVerifyIndexRouteImport.update({
    id: '/pcmp/disburse-verify/',
    path: '/pcmp/disburse-verify/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpDepartmentDivisionsIndexRoute =
  AuthPcmpDepartmentDivisionsIndexRouteImport.update({
    id: '/pcmp/department-divisions/',
    path: '/pcmp/department-divisions/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpCorrectionIndexRoute = AuthPcmpCorrectionIndexRouteImport.update({
  id: '/pcmp/correction/',
  path: '/pcmp/correction/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPcmpAccountsIndexRoute = AuthPcmpAccountsIndexRouteImport.update({
  id: '/pcmp/accounts/',
  path: '/pcmp/accounts/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMarketPromotionRegionSummaryIndexRoute =
  AuthMarketPromotionRegionSummaryIndexRouteImport.update({
    id: '/market-promotion/region-summary/',
    path: '/market-promotion/region-summary/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionPublishPanelIndexRoute =
  AuthMarketPromotionPublishPanelIndexRouteImport.update({
    id: '/market-promotion/publish-panel/',
    path: '/market-promotion/publish-panel/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionApprovalsIndexRoute =
  AuthMarketPromotionApprovalsIndexRouteImport.update({
    id: '/market-promotion/approvals/',
    path: '/market-promotion/approvals/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionAdjustmentIndexRoute =
  AuthMarketPromotionAdjustmentIndexRouteImport.update({
    id: '/market-promotion/adjustment/',
    path: '/market-promotion/adjustment/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthHrFormLeaveApplicationsIndexRoute =
  AuthHrFormLeaveApplicationsIndexRouteImport.update({
    id: '/hr-form/leave-applications/',
    path: '/hr-form/leave-applications/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGeoLocationMoTravelHistoryIndexRoute =
  AuthGeoLocationMoTravelHistoryIndexRouteImport.update({
    id: '/geo-location/mo-travel-history/',
    path: '/geo-location/mo-travel-history/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysIndexRoute =
  AuthFeedbackSurveysIndexRouteImport.update({
    id: '/feedback/surveys/',
    path: '/feedback/surveys/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackListIndexRoute = AuthFeedbackListIndexRouteImport.update({
  id: '/feedback/list/',
  path: '/feedback/list/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardsZonalStatementIndexRoute =
  AuthDashboardsZonalStatementIndexRouteImport.update({
    id: '/dashboards/zonal-statement/',
    path: '/dashboards/zonal-statement/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsSystemIndexRoute =
  AuthDashboardsSystemIndexRouteImport.update({
    id: '/dashboards/system/',
    path: '/dashboards/system/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsDcrIndexRoute = AuthDashboardsDcrIndexRouteImport.update({
  id: '/dashboards/dcr/',
  path: '/dashboards/dcr/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersCreateCategoryRoute = AuthUsersCreateCategoryRouteImport.update({
  id: '/users/create/$category',
  path: '/users/create/$category',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsTeacherSubmissionsTeacherIdRoute =
  AuthSettingsTeacherSubmissionsTeacherIdRouteImport.update({
    id: '/settings/teacher-submissions/$teacherId',
    path: '/settings/teacher-submissions/$teacherId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsTeacherInactivationsRequestIdRoute =
  AuthSettingsTeacherInactivationsRequestIdRouteImport.update({
    id: '/settings/teacher-inactivations/$requestId',
    path: '/settings/teacher-inactivations/$requestId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstitutesUserMappingRoute =
  AuthSettingsInstitutesUserMappingRouteImport.update({
    id: '/settings/institutes/user-mapping',
    path: '/settings/institutes/user-mapping',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstitutesCreateRoute =
  AuthSettingsInstitutesCreateRouteImport.update({
    id: '/settings/institutes/create',
    path: '/settings/institutes/create',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstituteSubmissionsSubmissionIdRoute =
  AuthSettingsInstituteSubmissionsSubmissionIdRouteImport.update({
    id: '/settings/institute-submissions/$submissionId',
    path: '/settings/institute-submissions/$submissionId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionPapersProjectInstituteIdRoute =
  AuthQuestionPapersProjectInstituteIdRouteImport.update({
    id: '/question/papers/$projectInstituteId',
    path: '/question/papers/$projectInstituteId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionMonitorDistrictsRoute =
  AuthQuestionMonitorDistrictsRouteImport.update({
    id: '/question/monitor/districts',
    path: '/question/monitor/districts',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionMonitorClassesRoute =
  AuthQuestionMonitorClassesRouteImport.update({
    id: '/question/monitor/classes',
    path: '/question/monitor/classes',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPublishBatchesBatchIdRoute =
  AuthPublishBatchesBatchIdRouteImport.update({
    id: '/publish/batches/$batchId',
    path: '/publish/batches/$batchId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductStudentCollectionProjectsProjectIdRoute =
  AuthProductStudentCollectionProjectsProjectIdRouteImport.update({
    id: '/product/student-collection-projects/$projectId',
    path: '/product/student-collection-projects/$projectId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductBooklistedInstitutionProjectIdRoute =
  AuthProductBooklistedInstitutionProjectIdRouteImport.update({
    id: '/product/booklisted-institution/$projectId',
    path: '/product/booklisted-institution/$projectId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpProjectsNewRoute = AuthPcmpProjectsNewRouteImport.update({
  id: '/pcmp/projects/new',
  path: '/pcmp/projects/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMarketPromotionRegionSummaryDonationsRoute =
  AuthMarketPromotionRegionSummaryDonationsRouteImport.update({
    id: '/market-promotion/region-summary/donations',
    path: '/market-promotion/region-summary/donations',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionPublishPanelNewRoute =
  AuthMarketPromotionPublishPanelNewRouteImport.update({
    id: '/market-promotion/publish-panel/new',
    path: '/market-promotion/publish-panel/new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionApprovalsDetailIdRoute =
  AuthMarketPromotionApprovalsDetailIdRouteImport.update({
    id: '/market-promotion/approvals/$detailId',
    path: '/market-promotion/approvals/$detailId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthHrFormLeaveApplicationsApplicationIdRoute =
  AuthHrFormLeaveApplicationsApplicationIdRouteImport.update({
    id: '/hr-form/leave-applications/$applicationId',
    path: '/hr-form/leave-applications/$applicationId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGeoLocationMoTravelHistoryUserIdRoute =
  AuthGeoLocationMoTravelHistoryUserIdRouteImport.update({
    id: '/geo-location/mo-travel-history/$userId',
    path: '/geo-location/mo-travel-history/$userId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysNewRoute = AuthFeedbackSurveysNewRouteImport.update({
  id: '/feedback/surveys/new',
  path: '/feedback/surveys/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeedbackListFeedbackIdRoute =
  AuthFeedbackListFeedbackIdRouteImport.update({
    id: '/feedback/list/$feedbackId',
    path: '/feedback/list/$feedbackId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsSystemUserIdRoute =
  AuthDashboardsSystemUserIdRouteImport.update({
    id: '/dashboards/system/$userId',
    path: '/dashboards/system/$userId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsDcrUserIdRoute = AuthDashboardsDcrUserIdRouteImport.update({
  id: '/dashboards/dcr/$userId',
  path: '/dashboards/dcr/$userId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQuestionMonitorInstitutesIndexRoute =
  AuthQuestionMonitorInstitutesIndexRouteImport.update({
    id: '/question/monitor/institutes/',
    path: '/question/monitor/institutes/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPromotionAdjustmentPromoItemIdIndexRoute =
  AuthPromotionAdjustmentPromoItemIdIndexRouteImport.update({
    id: '/promotion/adjustment/$promoItemId/',
    path: '/promotion/adjustment/$promoItemId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenDistributionSpecimenIdIndexRoute =
  AuthProductSpecimenDistributionSpecimenIdIndexRouteImport.update({
    id: '/product/specimen-distribution/$specimenId/',
    path: '/product/specimen-distribution/$specimenId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpRequestsRequestedIndexRoute =
  AuthPcmpRequestsRequestedIndexRouteImport.update({
    id: '/pcmp/requests/requested/',
    path: '/pcmp/requests/requested/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpReportsPerformanceIndexRoute =
  AuthPcmpReportsPerformanceIndexRouteImport.update({
    id: '/pcmp/reports/performance/',
    path: '/pcmp/reports/performance/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpReportsPendingIndexRoute =
  AuthPcmpReportsPendingIndexRouteImport.update({
    id: '/pcmp/reports/pending/',
    path: '/pcmp/reports/pending/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpReportsMoWiseIndexRoute =
  AuthPcmpReportsMoWiseIndexRouteImport.update({
    id: '/pcmp/reports/mo-wise/',
    path: '/pcmp/reports/mo-wise/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpReportsMisStatusIndexRoute =
  AuthPcmpReportsMisStatusIndexRouteImport.update({
    id: '/pcmp/reports/mis-status/',
    path: '/pcmp/reports/mis-status/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpProposalsProposalIdIndexRoute =
  AuthPcmpProposalsProposalIdIndexRouteImport.update({
    id: '/pcmp/proposals/$proposalId/',
    path: '/pcmp/proposals/$proposalId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpProjectsProjectIdIndexRoute =
  AuthPcmpProjectsProjectIdIndexRouteImport.update({
    id: '/pcmp/projects/$projectId/',
    path: '/pcmp/projects/$projectId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionAdjustmentPromoItemIdIndexRoute =
  AuthMarketPromotionAdjustmentPromoItemIdIndexRouteImport.update({
    id: '/market-promotion/adjustment/$promoItemId/',
    path: '/market-promotion/adjustment/$promoItemId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysSurveyIdIndexRoute =
  AuthFeedbackSurveysSurveyIdIndexRouteImport.update({
    id: '/feedback/surveys/$surveyId/',
    path: '/feedback/surveys/$surveyId/',
    getParentRoute: () => AuthRoute,
  } as any)
const PrintPcmpReportsPerformancePrintRoute =
  PrintPcmpReportsPerformancePrintRouteImport.update({
    id: '/pcmp/reports/performance/print',
    path: '/pcmp/reports/performance/print',
    getParentRoute: () => PrintRoute,
  } as any)
const PrintPcmpReportsPendingPrintRoute =
  PrintPcmpReportsPendingPrintRouteImport.update({
    id: '/pcmp/reports/pending/print',
    path: '/pcmp/reports/pending/print',
    getParentRoute: () => PrintRoute,
  } as any)
const PrintPcmpReportsMoWisePrintRoute =
  PrintPcmpReportsMoWisePrintRouteImport.update({
    id: '/pcmp/reports/mo-wise/print',
    path: '/pcmp/reports/mo-wise/print',
    getParentRoute: () => PrintRoute,
  } as any)
const PrintPcmpReportsMisStatusPrintRoute =
  PrintPcmpReportsMisStatusPrintRouteImport.update({
    id: '/pcmp/reports/mis-status/print',
    path: '/pcmp/reports/mis-status/print',
    getParentRoute: () => PrintRoute,
  } as any)
const PrintPcmpProposalsProposalIdPrintRoute =
  PrintPcmpProposalsProposalIdPrintRouteImport.update({
    id: '/pcmp/proposals/$proposalId/print',
    path: '/pcmp/proposals/$proposalId/print',
    getParentRoute: () => PrintRoute,
  } as any)
const AuthSettingsInstitutesInstituteIdEditRoute =
  AuthSettingsInstitutesInstituteIdEditRouteImport.update({
    id: '/settings/institutes/$instituteId/edit',
    path: '/settings/institutes/$instituteId/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionMonitorInstitutesProjectInstituteIdRoute =
  AuthQuestionMonitorInstitutesProjectInstituteIdRouteImport.update({
    id: '/question/monitor/institutes/$projectInstituteId',
    path: '/question/monitor/institutes/$projectInstituteId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPromotionAdjustmentPromoItemIdZmIdRoute =
  AuthPromotionAdjustmentPromoItemIdZmIdRouteImport.update({
    id: '/promotion/adjustment/$promoItemId/$zmId',
    path: '/promotion/adjustment/$promoItemId/$zmId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenDistributionSpecimenIdZmIdRoute =
  AuthProductSpecimenDistributionSpecimenIdZmIdRouteImport.update({
    id: '/product/specimen-distribution/$specimenId/$zmId',
    path: '/product/specimen-distribution/$specimenId/$zmId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpProjectsProjectIdEditRoute =
  AuthPcmpProjectsProjectIdEditRouteImport.update({
    id: '/pcmp/projects/$projectId/edit',
    path: '/pcmp/projects/$projectId/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpProjectsProjectIdCreatedRoute =
  AuthPcmpProjectsProjectIdCreatedRouteImport.update({
    id: '/pcmp/projects/$projectId/created',
    path: '/pcmp/projects/$projectId/created',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionPublishPanelZonalManagersUserIdRoute =
  AuthMarketPromotionPublishPanelZonalManagersUserIdRouteImport.update({
    id: '/market-promotion/publish-panel/zonal-managers/$userId',
    path: '/market-promotion/publish-panel/zonal-managers/$userId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionPublishPanelBatchesBatchIdRoute =
  AuthMarketPromotionPublishPanelBatchesBatchIdRouteImport.update({
    id: '/market-promotion/publish-panel/batches/$batchId',
    path: '/market-promotion/publish-panel/batches/$batchId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute =
  AuthMarketPromotionAdjustmentPromoItemIdZmIdRouteImport.update({
    id: '/market-promotion/adjustment/$promoItemId/$zmId',
    path: '/market-promotion/adjustment/$promoItemId/$zmId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysSurveyIdEditRoute =
  AuthFeedbackSurveysSurveyIdEditRouteImport.update({
    id: '/feedback/surveys/$surveyId/edit',
    path: '/feedback/surveys/$surveyId/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsZonalStatementUserIdSpecimenRoute =
  AuthDashboardsZonalStatementUserIdSpecimenRouteImport.update({
    id: '/dashboards/zonal-statement/$userId/specimen',
    path: '/dashboards/zonal-statement/$userId/specimen',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsZonalStatementUserIdExpenseRoute =
  AuthDashboardsZonalStatementUserIdExpenseRouteImport.update({
    id: '/dashboards/zonal-statement/$userId/expense',
    path: '/dashboards/zonal-statement/$userId/expense',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpRequestsBatchesBatchNoIndexRoute =
  AuthPcmpRequestsBatchesBatchNoIndexRouteImport.update({
    id: '/pcmp/requests/batches/$batchNo/',
    path: '/pcmp/requests/batches/$batchNo/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpMisBatchesBatchNoIndexRoute =
  AuthPcmpMisBatchesBatchNoIndexRouteImport.update({
    id: '/pcmp/mis/batches/$batchNo/',
    path: '/pcmp/mis/batches/$batchNo/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpMarketingBatchesBatchNoIndexRoute =
  AuthPcmpMarketingBatchesBatchNoIndexRouteImport.update({
    id: '/pcmp/marketing/batches/$batchNo/',
    path: '/pcmp/marketing/batches/$batchNo/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpAccountsRedisburseBatchesBatchNoIndexRoute =
  AuthPcmpAccountsRedisburseBatchesBatchNoIndexRouteImport.update({
    id: '/pcmp/accounts/redisburse-batches/$batchNo/',
    path: '/pcmp/accounts/redisburse-batches/$batchNo/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPcmpAccountsBatchesBatchNoIndexRoute =
  AuthPcmpAccountsBatchesBatchNoIndexRouteImport.update({
    id: '/pcmp/accounts/batches/$batchNo/',
    path: '/pcmp/accounts/batches/$batchNo/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysSurveyIdSubmissionsIndexRoute =
  AuthFeedbackSurveysSurveyIdSubmissionsIndexRouteImport.update({
    id: '/feedback/surveys/$surveyId/submissions/',
    path: '/feedback/surveys/$surveyId/submissions/',
    getParentRoute: () => AuthRoute,
  } as any)
const PrintPcmpRequestsBatchesBatchNoPrintRoute =
  PrintPcmpRequestsBatchesBatchNoPrintRouteImport.update({
    id: '/pcmp/requests/batches/$batchNo/print',
    path: '/pcmp/requests/batches/$batchNo/print',
    getParentRoute: () => PrintRoute,
  } as any)
const PrintPcmpMisBatchesBatchNoPrintRoute =
  PrintPcmpMisBatchesBatchNoPrintRouteImport.update({
    id: '/pcmp/mis/batches/$batchNo/print',
    path: '/pcmp/mis/batches/$batchNo/print',
    getParentRoute: () => PrintRoute,
  } as any)
const PrintPcmpAccountsRedisburseBatchesBatchNoPrintRoute =
  PrintPcmpAccountsRedisburseBatchesBatchNoPrintRouteImport.update({
    id: '/pcmp/accounts/redisburse-batches/$batchNo/print',
    path: '/pcmp/accounts/redisburse-batches/$batchNo/print',
    getParentRoute: () => PrintRoute,
  } as any)
const PrintPcmpAccountsBatchesBatchNoPrintRoute =
  PrintPcmpAccountsBatchesBatchNoPrintRouteImport.update({
    id: '/pcmp/accounts/batches/$batchNo/print',
    path: '/pcmp/accounts/batches/$batchNo/print',
    getParentRoute: () => PrintRoute,
  } as any)
const AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRoute =
  AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRouteImport.update({
    id: '/feedback/surveys/$surveyId/submissions/$submissionId',
    path: '/feedback/surveys/$surveyId/submissions/$submissionId',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/sso': typeof SsoRoute
  '/profile': typeof AuthProfileRoute
  '/login': typeof PublicLoginRoute
  '/attendance/employee-report': typeof AuthAttendanceEmployeeReportRoute
  '/attendance/job-card': typeof AuthAttendanceJobCardRoute
  '/attendance/shift-employee-report': typeof AuthAttendanceShiftEmployeeReportRoute
  '/attendance/shift-job-card': typeof AuthAttendanceShiftJobCardRoute
  '/billing/all-cost': typeof AuthBillingAllCostRoute
  '/billing/approval': typeof AuthBillingApprovalRoute
  '/billing/cost-amendment': typeof AuthBillingCostAmendmentRoute
  '/billing/dcr-approve': typeof AuthBillingDcrApproveRoute
  '/billing/expense-approve': typeof AuthBillingExpenseApproveRoute
  '/billing/offline-dcr-verify': typeof AuthBillingOfflineDcrVerifyRoute
  '/billing/offline-der-verify': typeof AuthBillingOfflineDerVerifyRoute
  '/billing/web-expense': typeof AuthBillingWebExpenseRoute
  '/dashboards/der': typeof AuthDashboardsDerRoute
  '/dashboards/pending': typeof AuthDashboardsPendingRoute
  '/feedback/types': typeof AuthFeedbackTypesRoute
  '/hr-form/leave-report': typeof AuthHrFormLeaveReportRoute
  '/market-promotion/accounts-adjust': typeof AuthMarketPromotionAccountsAdjustRoute
  '/market-promotion/approval-report': typeof AuthMarketPromotionApprovalReportRoute
  '/market-promotion/budget-entry': typeof AuthMarketPromotionBudgetEntryRoute
  '/market-promotion/cash-collection': typeof AuthMarketPromotionCashCollectionRoute
  '/market-promotion/distribution-summary': typeof AuthMarketPromotionDistributionSummaryRoute
  '/market-promotion/mis-approvals': typeof AuthMarketPromotionMisApprovalsRoute
  '/market-promotion/projects': typeof AuthMarketPromotionProjectsRoute
  '/market-promotion/requisitions': typeof AuthMarketPromotionRequisitionsRoute
  '/product/book-editions': typeof AuthProductBookEditionsRoute
  '/product/book-types': typeof AuthProductBookTypesRoute
  '/product/dcr-date-to-date': typeof AuthProductDcrDateToDateRoute
  '/product/dcr-sheet': typeof AuthProductDcrSheetRoute
  '/product/sp-promotional-requisition': typeof AuthProductSpPromotionalRequisitionRoute
  '/product/specimen-adjustment': typeof AuthProductSpecimenAdjustmentRoute
  '/product/specimen-institution': typeof AuthProductSpecimenInstitutionRoute
  '/product/specimen-list-view': typeof AuthProductSpecimenListViewRoute
  '/product/specimen-requisition': typeof AuthProductSpecimenRequisitionRoute
  '/product/specimen-requisition-review': typeof AuthProductSpecimenRequisitionReviewRoute
  '/product/specimens': typeof AuthProductSpecimensRoute
  '/promotion/distribution': typeof AuthPromotionDistributionRoute
  '/promotion/item-types': typeof AuthPromotionItemTypesRoute
  '/promotion/items': typeof AuthPromotionItemsRoute
  '/publish/accounts': typeof AuthPublishAccountsRoute
  '/publish/mis': typeof AuthPublishMisRoute
  '/publish/sales': typeof AuthPublishSalesRoute
  '/question/download': typeof AuthQuestionDownloadRoute
  '/question/download-by-board': typeof AuthQuestionDownloadByBoardRoute
  '/question/download-by-class': typeof AuthQuestionDownloadByClassRoute
  '/question/projects': typeof AuthQuestionProjectsRoute
  '/question/subjects': typeof AuthQuestionSubjectsRoute
  '/question/upload': typeof AuthQuestionUploadRoute
  '/reports/app-version-check': typeof AuthReportsAppVersionCheckRoute
  '/settings/feedback-types': typeof AuthSettingsFeedbackTypesRoute
  '/settings/holidays': typeof AuthSettingsHolidaysRoute
  '/settings/institute-types': typeof AuthSettingsInstituteTypesRoute
  '/settings/leave-types': typeof AuthSettingsLeaveTypesRoute
  '/settings/limit-types': typeof AuthSettingsLimitTypesRoute
  '/settings/menu-labels': typeof AuthSettingsMenuLabelsRoute
  '/settings/web-urls': typeof AuthSettingsWebUrlsRoute
  '/users/admin': typeof AuthUsersAdminRoute
  '/users/agent': typeof AuthUsersAgentRoute
  '/users/edit': typeof AuthUsersEditRoute
  '/users/general': typeof AuthUsersGeneralRoute
  '/users/marketing': typeof AuthUsersMarketingRoute
  '/users/permissions': typeof AuthUsersPermissionsRoute
  '/users/roles': typeof AuthUsersRolesRoute
  '/users/special': typeof AuthUsersSpecialRoute
  '/users/view': typeof AuthUsersViewRoute
  '/attendance/': typeof AuthAttendanceIndexRoute
  '/users/': typeof AuthUsersIndexRoute
  '/dashboards/dcr/$userId': typeof AuthDashboardsDcrUserIdRoute
  '/dashboards/system/$userId': typeof AuthDashboardsSystemUserIdRoute
  '/feedback/list/$feedbackId': typeof AuthFeedbackListFeedbackIdRoute
  '/feedback/surveys/new': typeof AuthFeedbackSurveysNewRoute
  '/geo-location/mo-travel-history/$userId': typeof AuthGeoLocationMoTravelHistoryUserIdRoute
  '/hr-form/leave-applications/$applicationId': typeof AuthHrFormLeaveApplicationsApplicationIdRoute
  '/market-promotion/approvals/$detailId': typeof AuthMarketPromotionApprovalsDetailIdRoute
  '/market-promotion/publish-panel/new': typeof AuthMarketPromotionPublishPanelNewRoute
  '/market-promotion/region-summary/donations': typeof AuthMarketPromotionRegionSummaryDonationsRoute
  '/pcmp/projects/new': typeof AuthPcmpProjectsNewRoute
  '/product/booklisted-institution/$projectId': typeof AuthProductBooklistedInstitutionProjectIdRoute
  '/product/student-collection-projects/$projectId': typeof AuthProductStudentCollectionProjectsProjectIdRoute
  '/publish/batches/$batchId': typeof AuthPublishBatchesBatchIdRoute
  '/question/monitor/classes': typeof AuthQuestionMonitorClassesRoute
  '/question/monitor/districts': typeof AuthQuestionMonitorDistrictsRoute
  '/question/papers/$projectInstituteId': typeof AuthQuestionPapersProjectInstituteIdRoute
  '/settings/institute-submissions/$submissionId': typeof AuthSettingsInstituteSubmissionsSubmissionIdRoute
  '/settings/institutes/create': typeof AuthSettingsInstitutesCreateRoute
  '/settings/institutes/user-mapping': typeof AuthSettingsInstitutesUserMappingRoute
  '/settings/teacher-inactivations/$requestId': typeof AuthSettingsTeacherInactivationsRequestIdRoute
  '/settings/teacher-submissions/$teacherId': typeof AuthSettingsTeacherSubmissionsTeacherIdRoute
  '/users/create/$category': typeof AuthUsersCreateCategoryRoute
  '/dashboards/dcr/': typeof AuthDashboardsDcrIndexRoute
  '/dashboards/system/': typeof AuthDashboardsSystemIndexRoute
  '/dashboards/zonal-statement/': typeof AuthDashboardsZonalStatementIndexRoute
  '/feedback/list/': typeof AuthFeedbackListIndexRoute
  '/feedback/surveys/': typeof AuthFeedbackSurveysIndexRoute
  '/geo-location/mo-travel-history/': typeof AuthGeoLocationMoTravelHistoryIndexRoute
  '/hr-form/leave-applications/': typeof AuthHrFormLeaveApplicationsIndexRoute
  '/market-promotion/adjustment/': typeof AuthMarketPromotionAdjustmentIndexRoute
  '/market-promotion/approvals/': typeof AuthMarketPromotionApprovalsIndexRoute
  '/market-promotion/publish-panel/': typeof AuthMarketPromotionPublishPanelIndexRoute
  '/market-promotion/region-summary/': typeof AuthMarketPromotionRegionSummaryIndexRoute
  '/pcmp/accounts/': typeof AuthPcmpAccountsIndexRoute
  '/pcmp/correction/': typeof AuthPcmpCorrectionIndexRoute
  '/pcmp/department-divisions/': typeof AuthPcmpDepartmentDivisionsIndexRoute
  '/pcmp/disburse-verify/': typeof AuthPcmpDisburseVerifyIndexRoute
  '/pcmp/edit-permissions/': typeof AuthPcmpEditPermissionsIndexRoute
  '/pcmp/marketing/': typeof AuthPcmpMarketingIndexRoute
  '/pcmp/mis/': typeof AuthPcmpMisIndexRoute
  '/pcmp/projects/': typeof AuthPcmpProjectsIndexRoute
  '/pcmp/request-categories/': typeof AuthPcmpRequestCategoriesIndexRoute
  '/pcmp/requests/': typeof AuthPcmpRequestsIndexRoute
  '/product/booklisted-institution/': typeof AuthProductBooklistedInstitutionIndexRoute
  '/product/specimen-distribution/': typeof AuthProductSpecimenDistributionIndexRoute
  '/product/student-collection-projects/': typeof AuthProductStudentCollectionProjectsIndexRoute
  '/promotion/adjustment/': typeof AuthPromotionAdjustmentIndexRoute
  '/settings/institute-submissions/': typeof AuthSettingsInstituteSubmissionsIndexRoute
  '/settings/institutes/': typeof AuthSettingsInstitutesIndexRoute
  '/settings/teacher-inactivations/': typeof AuthSettingsTeacherInactivationsIndexRoute
  '/settings/teacher-submissions/': typeof AuthSettingsTeacherSubmissionsIndexRoute
  '/dashboards/zonal-statement/$userId/expense': typeof AuthDashboardsZonalStatementUserIdExpenseRoute
  '/dashboards/zonal-statement/$userId/specimen': typeof AuthDashboardsZonalStatementUserIdSpecimenRoute
  '/feedback/surveys/$surveyId/edit': typeof AuthFeedbackSurveysSurveyIdEditRoute
  '/market-promotion/adjustment/$promoItemId/$zmId': typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute
  '/market-promotion/publish-panel/batches/$batchId': typeof AuthMarketPromotionPublishPanelBatchesBatchIdRoute
  '/market-promotion/publish-panel/zonal-managers/$userId': typeof AuthMarketPromotionPublishPanelZonalManagersUserIdRoute
  '/pcmp/projects/$projectId/created': typeof AuthPcmpProjectsProjectIdCreatedRoute
  '/pcmp/projects/$projectId/edit': typeof AuthPcmpProjectsProjectIdEditRoute
  '/product/specimen-distribution/$specimenId/$zmId': typeof AuthProductSpecimenDistributionSpecimenIdZmIdRoute
  '/promotion/adjustment/$promoItemId/$zmId': typeof AuthPromotionAdjustmentPromoItemIdZmIdRoute
  '/question/monitor/institutes/$projectInstituteId': typeof AuthQuestionMonitorInstitutesProjectInstituteIdRoute
  '/settings/institutes/$instituteId/edit': typeof AuthSettingsInstitutesInstituteIdEditRoute
  '/pcmp/proposals/$proposalId/print': typeof PrintPcmpProposalsProposalIdPrintRoute
  '/pcmp/reports/mis-status/print': typeof PrintPcmpReportsMisStatusPrintRoute
  '/pcmp/reports/mo-wise/print': typeof PrintPcmpReportsMoWisePrintRoute
  '/pcmp/reports/pending/print': typeof PrintPcmpReportsPendingPrintRoute
  '/pcmp/reports/performance/print': typeof PrintPcmpReportsPerformancePrintRoute
  '/feedback/surveys/$surveyId/': typeof AuthFeedbackSurveysSurveyIdIndexRoute
  '/market-promotion/adjustment/$promoItemId/': typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRoute
  '/pcmp/projects/$projectId/': typeof AuthPcmpProjectsProjectIdIndexRoute
  '/pcmp/proposals/$proposalId/': typeof AuthPcmpProposalsProposalIdIndexRoute
  '/pcmp/reports/mis-status/': typeof AuthPcmpReportsMisStatusIndexRoute
  '/pcmp/reports/mo-wise/': typeof AuthPcmpReportsMoWiseIndexRoute
  '/pcmp/reports/pending/': typeof AuthPcmpReportsPendingIndexRoute
  '/pcmp/reports/performance/': typeof AuthPcmpReportsPerformanceIndexRoute
  '/pcmp/requests/requested/': typeof AuthPcmpRequestsRequestedIndexRoute
  '/product/specimen-distribution/$specimenId/': typeof AuthProductSpecimenDistributionSpecimenIdIndexRoute
  '/promotion/adjustment/$promoItemId/': typeof AuthPromotionAdjustmentPromoItemIdIndexRoute
  '/question/monitor/institutes/': typeof AuthQuestionMonitorInstitutesIndexRoute
  '/feedback/surveys/$surveyId/submissions/$submissionId': typeof AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRoute
  '/pcmp/accounts/batches/$batchNo/print': typeof PrintPcmpAccountsBatchesBatchNoPrintRoute
  '/pcmp/accounts/redisburse-batches/$batchNo/print': typeof PrintPcmpAccountsRedisburseBatchesBatchNoPrintRoute
  '/pcmp/mis/batches/$batchNo/print': typeof PrintPcmpMisBatchesBatchNoPrintRoute
  '/pcmp/requests/batches/$batchNo/print': typeof PrintPcmpRequestsBatchesBatchNoPrintRoute
  '/feedback/surveys/$surveyId/submissions/': typeof AuthFeedbackSurveysSurveyIdSubmissionsIndexRoute
  '/pcmp/accounts/batches/$batchNo/': typeof AuthPcmpAccountsBatchesBatchNoIndexRoute
  '/pcmp/accounts/redisburse-batches/$batchNo/': typeof AuthPcmpAccountsRedisburseBatchesBatchNoIndexRoute
  '/pcmp/marketing/batches/$batchNo/': typeof AuthPcmpMarketingBatchesBatchNoIndexRoute
  '/pcmp/mis/batches/$batchNo/': typeof AuthPcmpMisBatchesBatchNoIndexRoute
  '/pcmp/requests/batches/$batchNo/': typeof AuthPcmpRequestsBatchesBatchNoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthIndexRoute
  '/sso': typeof SsoRoute
  '/profile': typeof AuthProfileRoute
  '/login': typeof PublicLoginRoute
  '/attendance/employee-report': typeof AuthAttendanceEmployeeReportRoute
  '/attendance/job-card': typeof AuthAttendanceJobCardRoute
  '/attendance/shift-employee-report': typeof AuthAttendanceShiftEmployeeReportRoute
  '/attendance/shift-job-card': typeof AuthAttendanceShiftJobCardRoute
  '/billing/all-cost': typeof AuthBillingAllCostRoute
  '/billing/approval': typeof AuthBillingApprovalRoute
  '/billing/cost-amendment': typeof AuthBillingCostAmendmentRoute
  '/billing/dcr-approve': typeof AuthBillingDcrApproveRoute
  '/billing/expense-approve': typeof AuthBillingExpenseApproveRoute
  '/billing/offline-dcr-verify': typeof AuthBillingOfflineDcrVerifyRoute
  '/billing/offline-der-verify': typeof AuthBillingOfflineDerVerifyRoute
  '/billing/web-expense': typeof AuthBillingWebExpenseRoute
  '/dashboards/der': typeof AuthDashboardsDerRoute
  '/dashboards/pending': typeof AuthDashboardsPendingRoute
  '/feedback/types': typeof AuthFeedbackTypesRoute
  '/hr-form/leave-report': typeof AuthHrFormLeaveReportRoute
  '/market-promotion/accounts-adjust': typeof AuthMarketPromotionAccountsAdjustRoute
  '/market-promotion/approval-report': typeof AuthMarketPromotionApprovalReportRoute
  '/market-promotion/budget-entry': typeof AuthMarketPromotionBudgetEntryRoute
  '/market-promotion/cash-collection': typeof AuthMarketPromotionCashCollectionRoute
  '/market-promotion/distribution-summary': typeof AuthMarketPromotionDistributionSummaryRoute
  '/market-promotion/mis-approvals': typeof AuthMarketPromotionMisApprovalsRoute
  '/market-promotion/projects': typeof AuthMarketPromotionProjectsRoute
  '/market-promotion/requisitions': typeof AuthMarketPromotionRequisitionsRoute
  '/product/book-editions': typeof AuthProductBookEditionsRoute
  '/product/book-types': typeof AuthProductBookTypesRoute
  '/product/dcr-date-to-date': typeof AuthProductDcrDateToDateRoute
  '/product/dcr-sheet': typeof AuthProductDcrSheetRoute
  '/product/sp-promotional-requisition': typeof AuthProductSpPromotionalRequisitionRoute
  '/product/specimen-adjustment': typeof AuthProductSpecimenAdjustmentRoute
  '/product/specimen-institution': typeof AuthProductSpecimenInstitutionRoute
  '/product/specimen-list-view': typeof AuthProductSpecimenListViewRoute
  '/product/specimen-requisition': typeof AuthProductSpecimenRequisitionRoute
  '/product/specimen-requisition-review': typeof AuthProductSpecimenRequisitionReviewRoute
  '/product/specimens': typeof AuthProductSpecimensRoute
  '/promotion/distribution': typeof AuthPromotionDistributionRoute
  '/promotion/item-types': typeof AuthPromotionItemTypesRoute
  '/promotion/items': typeof AuthPromotionItemsRoute
  '/publish/accounts': typeof AuthPublishAccountsRoute
  '/publish/mis': typeof AuthPublishMisRoute
  '/publish/sales': typeof AuthPublishSalesRoute
  '/question/download': typeof AuthQuestionDownloadRoute
  '/question/download-by-board': typeof AuthQuestionDownloadByBoardRoute
  '/question/download-by-class': typeof AuthQuestionDownloadByClassRoute
  '/question/projects': typeof AuthQuestionProjectsRoute
  '/question/subjects': typeof AuthQuestionSubjectsRoute
  '/question/upload': typeof AuthQuestionUploadRoute
  '/reports/app-version-check': typeof AuthReportsAppVersionCheckRoute
  '/settings/feedback-types': typeof AuthSettingsFeedbackTypesRoute
  '/settings/holidays': typeof AuthSettingsHolidaysRoute
  '/settings/institute-types': typeof AuthSettingsInstituteTypesRoute
  '/settings/leave-types': typeof AuthSettingsLeaveTypesRoute
  '/settings/limit-types': typeof AuthSettingsLimitTypesRoute
  '/settings/menu-labels': typeof AuthSettingsMenuLabelsRoute
  '/settings/web-urls': typeof AuthSettingsWebUrlsRoute
  '/users/admin': typeof AuthUsersAdminRoute
  '/users/agent': typeof AuthUsersAgentRoute
  '/users/edit': typeof AuthUsersEditRoute
  '/users/general': typeof AuthUsersGeneralRoute
  '/users/marketing': typeof AuthUsersMarketingRoute
  '/users/permissions': typeof AuthUsersPermissionsRoute
  '/users/roles': typeof AuthUsersRolesRoute
  '/users/special': typeof AuthUsersSpecialRoute
  '/users/view': typeof AuthUsersViewRoute
  '/attendance': typeof AuthAttendanceIndexRoute
  '/users': typeof AuthUsersIndexRoute
  '/dashboards/dcr/$userId': typeof AuthDashboardsDcrUserIdRoute
  '/dashboards/system/$userId': typeof AuthDashboardsSystemUserIdRoute
  '/feedback/list/$feedbackId': typeof AuthFeedbackListFeedbackIdRoute
  '/feedback/surveys/new': typeof AuthFeedbackSurveysNewRoute
  '/geo-location/mo-travel-history/$userId': typeof AuthGeoLocationMoTravelHistoryUserIdRoute
  '/hr-form/leave-applications/$applicationId': typeof AuthHrFormLeaveApplicationsApplicationIdRoute
  '/market-promotion/approvals/$detailId': typeof AuthMarketPromotionApprovalsDetailIdRoute
  '/market-promotion/publish-panel/new': typeof AuthMarketPromotionPublishPanelNewRoute
  '/market-promotion/region-summary/donations': typeof AuthMarketPromotionRegionSummaryDonationsRoute
  '/pcmp/projects/new': typeof AuthPcmpProjectsNewRoute
  '/product/booklisted-institution/$projectId': typeof AuthProductBooklistedInstitutionProjectIdRoute
  '/product/student-collection-projects/$projectId': typeof AuthProductStudentCollectionProjectsProjectIdRoute
  '/publish/batches/$batchId': typeof AuthPublishBatchesBatchIdRoute
  '/question/monitor/classes': typeof AuthQuestionMonitorClassesRoute
  '/question/monitor/districts': typeof AuthQuestionMonitorDistrictsRoute
  '/question/papers/$projectInstituteId': typeof AuthQuestionPapersProjectInstituteIdRoute
  '/settings/institute-submissions/$submissionId': typeof AuthSettingsInstituteSubmissionsSubmissionIdRoute
  '/settings/institutes/create': typeof AuthSettingsInstitutesCreateRoute
  '/settings/institutes/user-mapping': typeof AuthSettingsInstitutesUserMappingRoute
  '/settings/teacher-inactivations/$requestId': typeof AuthSettingsTeacherInactivationsRequestIdRoute
  '/settings/teacher-submissions/$teacherId': typeof AuthSettingsTeacherSubmissionsTeacherIdRoute
  '/users/create/$category': typeof AuthUsersCreateCategoryRoute
  '/dashboards/dcr': typeof AuthDashboardsDcrIndexRoute
  '/dashboards/system': typeof AuthDashboardsSystemIndexRoute
  '/dashboards/zonal-statement': typeof AuthDashboardsZonalStatementIndexRoute
  '/feedback/list': typeof AuthFeedbackListIndexRoute
  '/feedback/surveys': typeof AuthFeedbackSurveysIndexRoute
  '/geo-location/mo-travel-history': typeof AuthGeoLocationMoTravelHistoryIndexRoute
  '/hr-form/leave-applications': typeof AuthHrFormLeaveApplicationsIndexRoute
  '/market-promotion/adjustment': typeof AuthMarketPromotionAdjustmentIndexRoute
  '/market-promotion/approvals': typeof AuthMarketPromotionApprovalsIndexRoute
  '/market-promotion/publish-panel': typeof AuthMarketPromotionPublishPanelIndexRoute
  '/market-promotion/region-summary': typeof AuthMarketPromotionRegionSummaryIndexRoute
  '/pcmp/accounts': typeof AuthPcmpAccountsIndexRoute
  '/pcmp/correction': typeof AuthPcmpCorrectionIndexRoute
  '/pcmp/department-divisions': typeof AuthPcmpDepartmentDivisionsIndexRoute
  '/pcmp/disburse-verify': typeof AuthPcmpDisburseVerifyIndexRoute
  '/pcmp/edit-permissions': typeof AuthPcmpEditPermissionsIndexRoute
  '/pcmp/marketing': typeof AuthPcmpMarketingIndexRoute
  '/pcmp/mis': typeof AuthPcmpMisIndexRoute
  '/pcmp/projects': typeof AuthPcmpProjectsIndexRoute
  '/pcmp/request-categories': typeof AuthPcmpRequestCategoriesIndexRoute
  '/pcmp/requests': typeof AuthPcmpRequestsIndexRoute
  '/product/booklisted-institution': typeof AuthProductBooklistedInstitutionIndexRoute
  '/product/specimen-distribution': typeof AuthProductSpecimenDistributionIndexRoute
  '/product/student-collection-projects': typeof AuthProductStudentCollectionProjectsIndexRoute
  '/promotion/adjustment': typeof AuthPromotionAdjustmentIndexRoute
  '/settings/institute-submissions': typeof AuthSettingsInstituteSubmissionsIndexRoute
  '/settings/institutes': typeof AuthSettingsInstitutesIndexRoute
  '/settings/teacher-inactivations': typeof AuthSettingsTeacherInactivationsIndexRoute
  '/settings/teacher-submissions': typeof AuthSettingsTeacherSubmissionsIndexRoute
  '/dashboards/zonal-statement/$userId/expense': typeof AuthDashboardsZonalStatementUserIdExpenseRoute
  '/dashboards/zonal-statement/$userId/specimen': typeof AuthDashboardsZonalStatementUserIdSpecimenRoute
  '/feedback/surveys/$surveyId/edit': typeof AuthFeedbackSurveysSurveyIdEditRoute
  '/market-promotion/adjustment/$promoItemId/$zmId': typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute
  '/market-promotion/publish-panel/batches/$batchId': typeof AuthMarketPromotionPublishPanelBatchesBatchIdRoute
  '/market-promotion/publish-panel/zonal-managers/$userId': typeof AuthMarketPromotionPublishPanelZonalManagersUserIdRoute
  '/pcmp/projects/$projectId/created': typeof AuthPcmpProjectsProjectIdCreatedRoute
  '/pcmp/projects/$projectId/edit': typeof AuthPcmpProjectsProjectIdEditRoute
  '/product/specimen-distribution/$specimenId/$zmId': typeof AuthProductSpecimenDistributionSpecimenIdZmIdRoute
  '/promotion/adjustment/$promoItemId/$zmId': typeof AuthPromotionAdjustmentPromoItemIdZmIdRoute
  '/question/monitor/institutes/$projectInstituteId': typeof AuthQuestionMonitorInstitutesProjectInstituteIdRoute
  '/settings/institutes/$instituteId/edit': typeof AuthSettingsInstitutesInstituteIdEditRoute
  '/pcmp/proposals/$proposalId/print': typeof PrintPcmpProposalsProposalIdPrintRoute
  '/pcmp/reports/mis-status/print': typeof PrintPcmpReportsMisStatusPrintRoute
  '/pcmp/reports/mo-wise/print': typeof PrintPcmpReportsMoWisePrintRoute
  '/pcmp/reports/pending/print': typeof PrintPcmpReportsPendingPrintRoute
  '/pcmp/reports/performance/print': typeof PrintPcmpReportsPerformancePrintRoute
  '/feedback/surveys/$surveyId': typeof AuthFeedbackSurveysSurveyIdIndexRoute
  '/market-promotion/adjustment/$promoItemId': typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRoute
  '/pcmp/projects/$projectId': typeof AuthPcmpProjectsProjectIdIndexRoute
  '/pcmp/proposals/$proposalId': typeof AuthPcmpProposalsProposalIdIndexRoute
  '/pcmp/reports/mis-status': typeof AuthPcmpReportsMisStatusIndexRoute
  '/pcmp/reports/mo-wise': typeof AuthPcmpReportsMoWiseIndexRoute
  '/pcmp/reports/pending': typeof AuthPcmpReportsPendingIndexRoute
  '/pcmp/reports/performance': typeof AuthPcmpReportsPerformanceIndexRoute
  '/pcmp/requests/requested': typeof AuthPcmpRequestsRequestedIndexRoute
  '/product/specimen-distribution/$specimenId': typeof AuthProductSpecimenDistributionSpecimenIdIndexRoute
  '/promotion/adjustment/$promoItemId': typeof AuthPromotionAdjustmentPromoItemIdIndexRoute
  '/question/monitor/institutes': typeof AuthQuestionMonitorInstitutesIndexRoute
  '/feedback/surveys/$surveyId/submissions/$submissionId': typeof AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRoute
  '/pcmp/accounts/batches/$batchNo/print': typeof PrintPcmpAccountsBatchesBatchNoPrintRoute
  '/pcmp/accounts/redisburse-batches/$batchNo/print': typeof PrintPcmpAccountsRedisburseBatchesBatchNoPrintRoute
  '/pcmp/mis/batches/$batchNo/print': typeof PrintPcmpMisBatchesBatchNoPrintRoute
  '/pcmp/requests/batches/$batchNo/print': typeof PrintPcmpRequestsBatchesBatchNoPrintRoute
  '/feedback/surveys/$surveyId/submissions': typeof AuthFeedbackSurveysSurveyIdSubmissionsIndexRoute
  '/pcmp/accounts/batches/$batchNo': typeof AuthPcmpAccountsBatchesBatchNoIndexRoute
  '/pcmp/accounts/redisburse-batches/$batchNo': typeof AuthPcmpAccountsRedisburseBatchesBatchNoIndexRoute
  '/pcmp/marketing/batches/$batchNo': typeof AuthPcmpMarketingBatchesBatchNoIndexRoute
  '/pcmp/mis/batches/$batchNo': typeof AuthPcmpMisBatchesBatchNoIndexRoute
  '/pcmp/requests/batches/$batchNo': typeof AuthPcmpRequestsBatchesBatchNoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_print': typeof PrintRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/sso': typeof SsoRoute
  '/_auth/profile': typeof AuthProfileRoute
  '/_public/login': typeof PublicLoginRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/attendance/employee-report': typeof AuthAttendanceEmployeeReportRoute
  '/_auth/attendance/job-card': typeof AuthAttendanceJobCardRoute
  '/_auth/attendance/shift-employee-report': typeof AuthAttendanceShiftEmployeeReportRoute
  '/_auth/attendance/shift-job-card': typeof AuthAttendanceShiftJobCardRoute
  '/_auth/billing/all-cost': typeof AuthBillingAllCostRoute
  '/_auth/billing/approval': typeof AuthBillingApprovalRoute
  '/_auth/billing/cost-amendment': typeof AuthBillingCostAmendmentRoute
  '/_auth/billing/dcr-approve': typeof AuthBillingDcrApproveRoute
  '/_auth/billing/expense-approve': typeof AuthBillingExpenseApproveRoute
  '/_auth/billing/offline-dcr-verify': typeof AuthBillingOfflineDcrVerifyRoute
  '/_auth/billing/offline-der-verify': typeof AuthBillingOfflineDerVerifyRoute
  '/_auth/billing/web-expense': typeof AuthBillingWebExpenseRoute
  '/_auth/dashboards/der': typeof AuthDashboardsDerRoute
  '/_auth/dashboards/pending': typeof AuthDashboardsPendingRoute
  '/_auth/feedback/types': typeof AuthFeedbackTypesRoute
  '/_auth/hr-form/leave-report': typeof AuthHrFormLeaveReportRoute
  '/_auth/market-promotion/accounts-adjust': typeof AuthMarketPromotionAccountsAdjustRoute
  '/_auth/market-promotion/approval-report': typeof AuthMarketPromotionApprovalReportRoute
  '/_auth/market-promotion/budget-entry': typeof AuthMarketPromotionBudgetEntryRoute
  '/_auth/market-promotion/cash-collection': typeof AuthMarketPromotionCashCollectionRoute
  '/_auth/market-promotion/distribution-summary': typeof AuthMarketPromotionDistributionSummaryRoute
  '/_auth/market-promotion/mis-approvals': typeof AuthMarketPromotionMisApprovalsRoute
  '/_auth/market-promotion/projects': typeof AuthMarketPromotionProjectsRoute
  '/_auth/market-promotion/requisitions': typeof AuthMarketPromotionRequisitionsRoute
  '/_auth/product/book-editions': typeof AuthProductBookEditionsRoute
  '/_auth/product/book-types': typeof AuthProductBookTypesRoute
  '/_auth/product/dcr-date-to-date': typeof AuthProductDcrDateToDateRoute
  '/_auth/product/dcr-sheet': typeof AuthProductDcrSheetRoute
  '/_auth/product/sp-promotional-requisition': typeof AuthProductSpPromotionalRequisitionRoute
  '/_auth/product/specimen-adjustment': typeof AuthProductSpecimenAdjustmentRoute
  '/_auth/product/specimen-institution': typeof AuthProductSpecimenInstitutionRoute
  '/_auth/product/specimen-list-view': typeof AuthProductSpecimenListViewRoute
  '/_auth/product/specimen-requisition': typeof AuthProductSpecimenRequisitionRoute
  '/_auth/product/specimen-requisition-review': typeof AuthProductSpecimenRequisitionReviewRoute
  '/_auth/product/specimens': typeof AuthProductSpecimensRoute
  '/_auth/promotion/distribution': typeof AuthPromotionDistributionRoute
  '/_auth/promotion/item-types': typeof AuthPromotionItemTypesRoute
  '/_auth/promotion/items': typeof AuthPromotionItemsRoute
  '/_auth/publish/accounts': typeof AuthPublishAccountsRoute
  '/_auth/publish/mis': typeof AuthPublishMisRoute
  '/_auth/publish/sales': typeof AuthPublishSalesRoute
  '/_auth/question/download': typeof AuthQuestionDownloadRoute
  '/_auth/question/download-by-board': typeof AuthQuestionDownloadByBoardRoute
  '/_auth/question/download-by-class': typeof AuthQuestionDownloadByClassRoute
  '/_auth/question/projects': typeof AuthQuestionProjectsRoute
  '/_auth/question/subjects': typeof AuthQuestionSubjectsRoute
  '/_auth/question/upload': typeof AuthQuestionUploadRoute
  '/_auth/reports/app-version-check': typeof AuthReportsAppVersionCheckRoute
  '/_auth/settings/feedback-types': typeof AuthSettingsFeedbackTypesRoute
  '/_auth/settings/holidays': typeof AuthSettingsHolidaysRoute
  '/_auth/settings/institute-types': typeof AuthSettingsInstituteTypesRoute
  '/_auth/settings/leave-types': typeof AuthSettingsLeaveTypesRoute
  '/_auth/settings/limit-types': typeof AuthSettingsLimitTypesRoute
  '/_auth/settings/menu-labels': typeof AuthSettingsMenuLabelsRoute
  '/_auth/settings/web-urls': typeof AuthSettingsWebUrlsRoute
  '/_auth/users/admin': typeof AuthUsersAdminRoute
  '/_auth/users/agent': typeof AuthUsersAgentRoute
  '/_auth/users/edit': typeof AuthUsersEditRoute
  '/_auth/users/general': typeof AuthUsersGeneralRoute
  '/_auth/users/marketing': typeof AuthUsersMarketingRoute
  '/_auth/users/permissions': typeof AuthUsersPermissionsRoute
  '/_auth/users/roles': typeof AuthUsersRolesRoute
  '/_auth/users/special': typeof AuthUsersSpecialRoute
  '/_auth/users/view': typeof AuthUsersViewRoute
  '/_auth/attendance/': typeof AuthAttendanceIndexRoute
  '/_auth/users/': typeof AuthUsersIndexRoute
  '/_auth/dashboards/dcr/$userId': typeof AuthDashboardsDcrUserIdRoute
  '/_auth/dashboards/system/$userId': typeof AuthDashboardsSystemUserIdRoute
  '/_auth/feedback/list/$feedbackId': typeof AuthFeedbackListFeedbackIdRoute
  '/_auth/feedback/surveys/new': typeof AuthFeedbackSurveysNewRoute
  '/_auth/geo-location/mo-travel-history/$userId': typeof AuthGeoLocationMoTravelHistoryUserIdRoute
  '/_auth/hr-form/leave-applications/$applicationId': typeof AuthHrFormLeaveApplicationsApplicationIdRoute
  '/_auth/market-promotion/approvals/$detailId': typeof AuthMarketPromotionApprovalsDetailIdRoute
  '/_auth/market-promotion/publish-panel/new': typeof AuthMarketPromotionPublishPanelNewRoute
  '/_auth/market-promotion/region-summary/donations': typeof AuthMarketPromotionRegionSummaryDonationsRoute
  '/_auth/pcmp/projects/new': typeof AuthPcmpProjectsNewRoute
  '/_auth/product/booklisted-institution/$projectId': typeof AuthProductBooklistedInstitutionProjectIdRoute
  '/_auth/product/student-collection-projects/$projectId': typeof AuthProductStudentCollectionProjectsProjectIdRoute
  '/_auth/publish/batches/$batchId': typeof AuthPublishBatchesBatchIdRoute
  '/_auth/question/monitor/classes': typeof AuthQuestionMonitorClassesRoute
  '/_auth/question/monitor/districts': typeof AuthQuestionMonitorDistrictsRoute
  '/_auth/question/papers/$projectInstituteId': typeof AuthQuestionPapersProjectInstituteIdRoute
  '/_auth/settings/institute-submissions/$submissionId': typeof AuthSettingsInstituteSubmissionsSubmissionIdRoute
  '/_auth/settings/institutes/create': typeof AuthSettingsInstitutesCreateRoute
  '/_auth/settings/institutes/user-mapping': typeof AuthSettingsInstitutesUserMappingRoute
  '/_auth/settings/teacher-inactivations/$requestId': typeof AuthSettingsTeacherInactivationsRequestIdRoute
  '/_auth/settings/teacher-submissions/$teacherId': typeof AuthSettingsTeacherSubmissionsTeacherIdRoute
  '/_auth/users/create/$category': typeof AuthUsersCreateCategoryRoute
  '/_auth/dashboards/dcr/': typeof AuthDashboardsDcrIndexRoute
  '/_auth/dashboards/system/': typeof AuthDashboardsSystemIndexRoute
  '/_auth/dashboards/zonal-statement/': typeof AuthDashboardsZonalStatementIndexRoute
  '/_auth/feedback/list/': typeof AuthFeedbackListIndexRoute
  '/_auth/feedback/surveys/': typeof AuthFeedbackSurveysIndexRoute
  '/_auth/geo-location/mo-travel-history/': typeof AuthGeoLocationMoTravelHistoryIndexRoute
  '/_auth/hr-form/leave-applications/': typeof AuthHrFormLeaveApplicationsIndexRoute
  '/_auth/market-promotion/adjustment/': typeof AuthMarketPromotionAdjustmentIndexRoute
  '/_auth/market-promotion/approvals/': typeof AuthMarketPromotionApprovalsIndexRoute
  '/_auth/market-promotion/publish-panel/': typeof AuthMarketPromotionPublishPanelIndexRoute
  '/_auth/market-promotion/region-summary/': typeof AuthMarketPromotionRegionSummaryIndexRoute
  '/_auth/pcmp/accounts/': typeof AuthPcmpAccountsIndexRoute
  '/_auth/pcmp/correction/': typeof AuthPcmpCorrectionIndexRoute
  '/_auth/pcmp/department-divisions/': typeof AuthPcmpDepartmentDivisionsIndexRoute
  '/_auth/pcmp/disburse-verify/': typeof AuthPcmpDisburseVerifyIndexRoute
  '/_auth/pcmp/edit-permissions/': typeof AuthPcmpEditPermissionsIndexRoute
  '/_auth/pcmp/marketing/': typeof AuthPcmpMarketingIndexRoute
  '/_auth/pcmp/mis/': typeof AuthPcmpMisIndexRoute
  '/_auth/pcmp/projects/': typeof AuthPcmpProjectsIndexRoute
  '/_auth/pcmp/request-categories/': typeof AuthPcmpRequestCategoriesIndexRoute
  '/_auth/pcmp/requests/': typeof AuthPcmpRequestsIndexRoute
  '/_auth/product/booklisted-institution/': typeof AuthProductBooklistedInstitutionIndexRoute
  '/_auth/product/specimen-distribution/': typeof AuthProductSpecimenDistributionIndexRoute
  '/_auth/product/student-collection-projects/': typeof AuthProductStudentCollectionProjectsIndexRoute
  '/_auth/promotion/adjustment/': typeof AuthPromotionAdjustmentIndexRoute
  '/_auth/settings/institute-submissions/': typeof AuthSettingsInstituteSubmissionsIndexRoute
  '/_auth/settings/institutes/': typeof AuthSettingsInstitutesIndexRoute
  '/_auth/settings/teacher-inactivations/': typeof AuthSettingsTeacherInactivationsIndexRoute
  '/_auth/settings/teacher-submissions/': typeof AuthSettingsTeacherSubmissionsIndexRoute
  '/_auth/dashboards/zonal-statement/$userId/expense': typeof AuthDashboardsZonalStatementUserIdExpenseRoute
  '/_auth/dashboards/zonal-statement/$userId/specimen': typeof AuthDashboardsZonalStatementUserIdSpecimenRoute
  '/_auth/feedback/surveys/$surveyId/edit': typeof AuthFeedbackSurveysSurveyIdEditRoute
  '/_auth/market-promotion/adjustment/$promoItemId/$zmId': typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute
  '/_auth/market-promotion/publish-panel/batches/$batchId': typeof AuthMarketPromotionPublishPanelBatchesBatchIdRoute
  '/_auth/market-promotion/publish-panel/zonal-managers/$userId': typeof AuthMarketPromotionPublishPanelZonalManagersUserIdRoute
  '/_auth/pcmp/projects/$projectId/created': typeof AuthPcmpProjectsProjectIdCreatedRoute
  '/_auth/pcmp/projects/$projectId/edit': typeof AuthPcmpProjectsProjectIdEditRoute
  '/_auth/product/specimen-distribution/$specimenId/$zmId': typeof AuthProductSpecimenDistributionSpecimenIdZmIdRoute
  '/_auth/promotion/adjustment/$promoItemId/$zmId': typeof AuthPromotionAdjustmentPromoItemIdZmIdRoute
  '/_auth/question/monitor/institutes/$projectInstituteId': typeof AuthQuestionMonitorInstitutesProjectInstituteIdRoute
  '/_auth/settings/institutes/$instituteId/edit': typeof AuthSettingsInstitutesInstituteIdEditRoute
  '/_print/pcmp/proposals/$proposalId/print': typeof PrintPcmpProposalsProposalIdPrintRoute
  '/_print/pcmp/reports/mis-status/print': typeof PrintPcmpReportsMisStatusPrintRoute
  '/_print/pcmp/reports/mo-wise/print': typeof PrintPcmpReportsMoWisePrintRoute
  '/_print/pcmp/reports/pending/print': typeof PrintPcmpReportsPendingPrintRoute
  '/_print/pcmp/reports/performance/print': typeof PrintPcmpReportsPerformancePrintRoute
  '/_auth/feedback/surveys/$surveyId/': typeof AuthFeedbackSurveysSurveyIdIndexRoute
  '/_auth/market-promotion/adjustment/$promoItemId/': typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRoute
  '/_auth/pcmp/projects/$projectId/': typeof AuthPcmpProjectsProjectIdIndexRoute
  '/_auth/pcmp/proposals/$proposalId/': typeof AuthPcmpProposalsProposalIdIndexRoute
  '/_auth/pcmp/reports/mis-status/': typeof AuthPcmpReportsMisStatusIndexRoute
  '/_auth/pcmp/reports/mo-wise/': typeof AuthPcmpReportsMoWiseIndexRoute
  '/_auth/pcmp/reports/pending/': typeof AuthPcmpReportsPendingIndexRoute
  '/_auth/pcmp/reports/performance/': typeof AuthPcmpReportsPerformanceIndexRoute
  '/_auth/pcmp/requests/requested/': typeof AuthPcmpRequestsRequestedIndexRoute
  '/_auth/product/specimen-distribution/$specimenId/': typeof AuthProductSpecimenDistributionSpecimenIdIndexRoute
  '/_auth/promotion/adjustment/$promoItemId/': typeof AuthPromotionAdjustmentPromoItemIdIndexRoute
  '/_auth/question/monitor/institutes/': typeof AuthQuestionMonitorInstitutesIndexRoute
  '/_auth/feedback/surveys/$surveyId/submissions/$submissionId': typeof AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRoute
  '/_print/pcmp/accounts/batches/$batchNo/print': typeof PrintPcmpAccountsBatchesBatchNoPrintRoute
  '/_print/pcmp/accounts/redisburse-batches/$batchNo/print': typeof PrintPcmpAccountsRedisburseBatchesBatchNoPrintRoute
  '/_print/pcmp/mis/batches/$batchNo/print': typeof PrintPcmpMisBatchesBatchNoPrintRoute
  '/_print/pcmp/requests/batches/$batchNo/print': typeof PrintPcmpRequestsBatchesBatchNoPrintRoute
  '/_auth/feedback/surveys/$surveyId/submissions/': typeof AuthFeedbackSurveysSurveyIdSubmissionsIndexRoute
  '/_auth/pcmp/accounts/batches/$batchNo/': typeof AuthPcmpAccountsBatchesBatchNoIndexRoute
  '/_auth/pcmp/accounts/redisburse-batches/$batchNo/': typeof AuthPcmpAccountsRedisburseBatchesBatchNoIndexRoute
  '/_auth/pcmp/marketing/batches/$batchNo/': typeof AuthPcmpMarketingBatchesBatchNoIndexRoute
  '/_auth/pcmp/mis/batches/$batchNo/': typeof AuthPcmpMisBatchesBatchNoIndexRoute
  '/_auth/pcmp/requests/batches/$batchNo/': typeof AuthPcmpRequestsBatchesBatchNoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sso'
    | '/profile'
    | '/login'
    | '/attendance/employee-report'
    | '/attendance/job-card'
    | '/attendance/shift-employee-report'
    | '/attendance/shift-job-card'
    | '/billing/all-cost'
    | '/billing/approval'
    | '/billing/cost-amendment'
    | '/billing/dcr-approve'
    | '/billing/expense-approve'
    | '/billing/offline-dcr-verify'
    | '/billing/offline-der-verify'
    | '/billing/web-expense'
    | '/dashboards/der'
    | '/dashboards/pending'
    | '/feedback/types'
    | '/hr-form/leave-report'
    | '/market-promotion/accounts-adjust'
    | '/market-promotion/approval-report'
    | '/market-promotion/budget-entry'
    | '/market-promotion/cash-collection'
    | '/market-promotion/distribution-summary'
    | '/market-promotion/mis-approvals'
    | '/market-promotion/projects'
    | '/market-promotion/requisitions'
    | '/product/book-editions'
    | '/product/book-types'
    | '/product/dcr-date-to-date'
    | '/product/dcr-sheet'
    | '/product/sp-promotional-requisition'
    | '/product/specimen-adjustment'
    | '/product/specimen-institution'
    | '/product/specimen-list-view'
    | '/product/specimen-requisition'
    | '/product/specimen-requisition-review'
    | '/product/specimens'
    | '/promotion/distribution'
    | '/promotion/item-types'
    | '/promotion/items'
    | '/publish/accounts'
    | '/publish/mis'
    | '/publish/sales'
    | '/question/download'
    | '/question/download-by-board'
    | '/question/download-by-class'
    | '/question/projects'
    | '/question/subjects'
    | '/question/upload'
    | '/reports/app-version-check'
    | '/settings/feedback-types'
    | '/settings/holidays'
    | '/settings/institute-types'
    | '/settings/leave-types'
    | '/settings/limit-types'
    | '/settings/menu-labels'
    | '/settings/web-urls'
    | '/users/admin'
    | '/users/agent'
    | '/users/edit'
    | '/users/general'
    | '/users/marketing'
    | '/users/permissions'
    | '/users/roles'
    | '/users/special'
    | '/users/view'
    | '/attendance/'
    | '/users/'
    | '/dashboards/dcr/$userId'
    | '/dashboards/system/$userId'
    | '/feedback/list/$feedbackId'
    | '/feedback/surveys/new'
    | '/geo-location/mo-travel-history/$userId'
    | '/hr-form/leave-applications/$applicationId'
    | '/market-promotion/approvals/$detailId'
    | '/market-promotion/publish-panel/new'
    | '/market-promotion/region-summary/donations'
    | '/pcmp/projects/new'
    | '/product/booklisted-institution/$projectId'
    | '/product/student-collection-projects/$projectId'
    | '/publish/batches/$batchId'
    | '/question/monitor/classes'
    | '/question/monitor/districts'
    | '/question/papers/$projectInstituteId'
    | '/settings/institute-submissions/$submissionId'
    | '/settings/institutes/create'
    | '/settings/institutes/user-mapping'
    | '/settings/teacher-inactivations/$requestId'
    | '/settings/teacher-submissions/$teacherId'
    | '/users/create/$category'
    | '/dashboards/dcr/'
    | '/dashboards/system/'
    | '/dashboards/zonal-statement/'
    | '/feedback/list/'
    | '/feedback/surveys/'
    | '/geo-location/mo-travel-history/'
    | '/hr-form/leave-applications/'
    | '/market-promotion/adjustment/'
    | '/market-promotion/approvals/'
    | '/market-promotion/publish-panel/'
    | '/market-promotion/region-summary/'
    | '/pcmp/accounts/'
    | '/pcmp/correction/'
    | '/pcmp/department-divisions/'
    | '/pcmp/disburse-verify/'
    | '/pcmp/edit-permissions/'
    | '/pcmp/marketing/'
    | '/pcmp/mis/'
    | '/pcmp/projects/'
    | '/pcmp/request-categories/'
    | '/pcmp/requests/'
    | '/product/booklisted-institution/'
    | '/product/specimen-distribution/'
    | '/product/student-collection-projects/'
    | '/promotion/adjustment/'
    | '/settings/institute-submissions/'
    | '/settings/institutes/'
    | '/settings/teacher-inactivations/'
    | '/settings/teacher-submissions/'
    | '/dashboards/zonal-statement/$userId/expense'
    | '/dashboards/zonal-statement/$userId/specimen'
    | '/feedback/surveys/$surveyId/edit'
    | '/market-promotion/adjustment/$promoItemId/$zmId'
    | '/market-promotion/publish-panel/batches/$batchId'
    | '/market-promotion/publish-panel/zonal-managers/$userId'
    | '/pcmp/projects/$projectId/created'
    | '/pcmp/projects/$projectId/edit'
    | '/product/specimen-distribution/$specimenId/$zmId'
    | '/promotion/adjustment/$promoItemId/$zmId'
    | '/question/monitor/institutes/$projectInstituteId'
    | '/settings/institutes/$instituteId/edit'
    | '/pcmp/proposals/$proposalId/print'
    | '/pcmp/reports/mis-status/print'
    | '/pcmp/reports/mo-wise/print'
    | '/pcmp/reports/pending/print'
    | '/pcmp/reports/performance/print'
    | '/feedback/surveys/$surveyId/'
    | '/market-promotion/adjustment/$promoItemId/'
    | '/pcmp/projects/$projectId/'
    | '/pcmp/proposals/$proposalId/'
    | '/pcmp/reports/mis-status/'
    | '/pcmp/reports/mo-wise/'
    | '/pcmp/reports/pending/'
    | '/pcmp/reports/performance/'
    | '/pcmp/requests/requested/'
    | '/product/specimen-distribution/$specimenId/'
    | '/promotion/adjustment/$promoItemId/'
    | '/question/monitor/institutes/'
    | '/feedback/surveys/$surveyId/submissions/$submissionId'
    | '/pcmp/accounts/batches/$batchNo/print'
    | '/pcmp/accounts/redisburse-batches/$batchNo/print'
    | '/pcmp/mis/batches/$batchNo/print'
    | '/pcmp/requests/batches/$batchNo/print'
    | '/feedback/surveys/$surveyId/submissions/'
    | '/pcmp/accounts/batches/$batchNo/'
    | '/pcmp/accounts/redisburse-batches/$batchNo/'
    | '/pcmp/marketing/batches/$batchNo/'
    | '/pcmp/mis/batches/$batchNo/'
    | '/pcmp/requests/batches/$batchNo/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sso'
    | '/profile'
    | '/login'
    | '/attendance/employee-report'
    | '/attendance/job-card'
    | '/attendance/shift-employee-report'
    | '/attendance/shift-job-card'
    | '/billing/all-cost'
    | '/billing/approval'
    | '/billing/cost-amendment'
    | '/billing/dcr-approve'
    | '/billing/expense-approve'
    | '/billing/offline-dcr-verify'
    | '/billing/offline-der-verify'
    | '/billing/web-expense'
    | '/dashboards/der'
    | '/dashboards/pending'
    | '/feedback/types'
    | '/hr-form/leave-report'
    | '/market-promotion/accounts-adjust'
    | '/market-promotion/approval-report'
    | '/market-promotion/budget-entry'
    | '/market-promotion/cash-collection'
    | '/market-promotion/distribution-summary'
    | '/market-promotion/mis-approvals'
    | '/market-promotion/projects'
    | '/market-promotion/requisitions'
    | '/product/book-editions'
    | '/product/book-types'
    | '/product/dcr-date-to-date'
    | '/product/dcr-sheet'
    | '/product/sp-promotional-requisition'
    | '/product/specimen-adjustment'
    | '/product/specimen-institution'
    | '/product/specimen-list-view'
    | '/product/specimen-requisition'
    | '/product/specimen-requisition-review'
    | '/product/specimens'
    | '/promotion/distribution'
    | '/promotion/item-types'
    | '/promotion/items'
    | '/publish/accounts'
    | '/publish/mis'
    | '/publish/sales'
    | '/question/download'
    | '/question/download-by-board'
    | '/question/download-by-class'
    | '/question/projects'
    | '/question/subjects'
    | '/question/upload'
    | '/reports/app-version-check'
    | '/settings/feedback-types'
    | '/settings/holidays'
    | '/settings/institute-types'
    | '/settings/leave-types'
    | '/settings/limit-types'
    | '/settings/menu-labels'
    | '/settings/web-urls'
    | '/users/admin'
    | '/users/agent'
    | '/users/edit'
    | '/users/general'
    | '/users/marketing'
    | '/users/permissions'
    | '/users/roles'
    | '/users/special'
    | '/users/view'
    | '/attendance'
    | '/users'
    | '/dashboards/dcr/$userId'
    | '/dashboards/system/$userId'
    | '/feedback/list/$feedbackId'
    | '/feedback/surveys/new'
    | '/geo-location/mo-travel-history/$userId'
    | '/hr-form/leave-applications/$applicationId'
    | '/market-promotion/approvals/$detailId'
    | '/market-promotion/publish-panel/new'
    | '/market-promotion/region-summary/donations'
    | '/pcmp/projects/new'
    | '/product/booklisted-institution/$projectId'
    | '/product/student-collection-projects/$projectId'
    | '/publish/batches/$batchId'
    | '/question/monitor/classes'
    | '/question/monitor/districts'
    | '/question/papers/$projectInstituteId'
    | '/settings/institute-submissions/$submissionId'
    | '/settings/institutes/create'
    | '/settings/institutes/user-mapping'
    | '/settings/teacher-inactivations/$requestId'
    | '/settings/teacher-submissions/$teacherId'
    | '/users/create/$category'
    | '/dashboards/dcr'
    | '/dashboards/system'
    | '/dashboards/zonal-statement'
    | '/feedback/list'
    | '/feedback/surveys'
    | '/geo-location/mo-travel-history'
    | '/hr-form/leave-applications'
    | '/market-promotion/adjustment'
    | '/market-promotion/approvals'
    | '/market-promotion/publish-panel'
    | '/market-promotion/region-summary'
    | '/pcmp/accounts'
    | '/pcmp/correction'
    | '/pcmp/department-divisions'
    | '/pcmp/disburse-verify'
    | '/pcmp/edit-permissions'
    | '/pcmp/marketing'
    | '/pcmp/mis'
    | '/pcmp/projects'
    | '/pcmp/request-categories'
    | '/pcmp/requests'
    | '/product/booklisted-institution'
    | '/product/specimen-distribution'
    | '/product/student-collection-projects'
    | '/promotion/adjustment'
    | '/settings/institute-submissions'
    | '/settings/institutes'
    | '/settings/teacher-inactivations'
    | '/settings/teacher-submissions'
    | '/dashboards/zonal-statement/$userId/expense'
    | '/dashboards/zonal-statement/$userId/specimen'
    | '/feedback/surveys/$surveyId/edit'
    | '/market-promotion/adjustment/$promoItemId/$zmId'
    | '/market-promotion/publish-panel/batches/$batchId'
    | '/market-promotion/publish-panel/zonal-managers/$userId'
    | '/pcmp/projects/$projectId/created'
    | '/pcmp/projects/$projectId/edit'
    | '/product/specimen-distribution/$specimenId/$zmId'
    | '/promotion/adjustment/$promoItemId/$zmId'
    | '/question/monitor/institutes/$projectInstituteId'
    | '/settings/institutes/$instituteId/edit'
    | '/pcmp/proposals/$proposalId/print'
    | '/pcmp/reports/mis-status/print'
    | '/pcmp/reports/mo-wise/print'
    | '/pcmp/reports/pending/print'
    | '/pcmp/reports/performance/print'
    | '/feedback/surveys/$surveyId'
    | '/market-promotion/adjustment/$promoItemId'
    | '/pcmp/projects/$projectId'
    | '/pcmp/proposals/$proposalId'
    | '/pcmp/reports/mis-status'
    | '/pcmp/reports/mo-wise'
    | '/pcmp/reports/pending'
    | '/pcmp/reports/performance'
    | '/pcmp/requests/requested'
    | '/product/specimen-distribution/$specimenId'
    | '/promotion/adjustment/$promoItemId'
    | '/question/monitor/institutes'
    | '/feedback/surveys/$surveyId/submissions/$submissionId'
    | '/pcmp/accounts/batches/$batchNo/print'
    | '/pcmp/accounts/redisburse-batches/$batchNo/print'
    | '/pcmp/mis/batches/$batchNo/print'
    | '/pcmp/requests/batches/$batchNo/print'
    | '/feedback/surveys/$surveyId/submissions'
    | '/pcmp/accounts/batches/$batchNo'
    | '/pcmp/accounts/redisburse-batches/$batchNo'
    | '/pcmp/marketing/batches/$batchNo'
    | '/pcmp/mis/batches/$batchNo'
    | '/pcmp/requests/batches/$batchNo'
  id:
    | '__root__'
    | '/_auth'
    | '/_print'
    | '/_public'
    | '/sso'
    | '/_auth/profile'
    | '/_public/login'
    | '/_auth/'
    | '/_auth/attendance/employee-report'
    | '/_auth/attendance/job-card'
    | '/_auth/attendance/shift-employee-report'
    | '/_auth/attendance/shift-job-card'
    | '/_auth/billing/all-cost'
    | '/_auth/billing/approval'
    | '/_auth/billing/cost-amendment'
    | '/_auth/billing/dcr-approve'
    | '/_auth/billing/expense-approve'
    | '/_auth/billing/offline-dcr-verify'
    | '/_auth/billing/offline-der-verify'
    | '/_auth/billing/web-expense'
    | '/_auth/dashboards/der'
    | '/_auth/dashboards/pending'
    | '/_auth/feedback/types'
    | '/_auth/hr-form/leave-report'
    | '/_auth/market-promotion/accounts-adjust'
    | '/_auth/market-promotion/approval-report'
    | '/_auth/market-promotion/budget-entry'
    | '/_auth/market-promotion/cash-collection'
    | '/_auth/market-promotion/distribution-summary'
    | '/_auth/market-promotion/mis-approvals'
    | '/_auth/market-promotion/projects'
    | '/_auth/market-promotion/requisitions'
    | '/_auth/product/book-editions'
    | '/_auth/product/book-types'
    | '/_auth/product/dcr-date-to-date'
    | '/_auth/product/dcr-sheet'
    | '/_auth/product/sp-promotional-requisition'
    | '/_auth/product/specimen-adjustment'
    | '/_auth/product/specimen-institution'
    | '/_auth/product/specimen-list-view'
    | '/_auth/product/specimen-requisition'
    | '/_auth/product/specimen-requisition-review'
    | '/_auth/product/specimens'
    | '/_auth/promotion/distribution'
    | '/_auth/promotion/item-types'
    | '/_auth/promotion/items'
    | '/_auth/publish/accounts'
    | '/_auth/publish/mis'
    | '/_auth/publish/sales'
    | '/_auth/question/download'
    | '/_auth/question/download-by-board'
    | '/_auth/question/download-by-class'
    | '/_auth/question/projects'
    | '/_auth/question/subjects'
    | '/_auth/question/upload'
    | '/_auth/reports/app-version-check'
    | '/_auth/settings/feedback-types'
    | '/_auth/settings/holidays'
    | '/_auth/settings/institute-types'
    | '/_auth/settings/leave-types'
    | '/_auth/settings/limit-types'
    | '/_auth/settings/menu-labels'
    | '/_auth/settings/web-urls'
    | '/_auth/users/admin'
    | '/_auth/users/agent'
    | '/_auth/users/edit'
    | '/_auth/users/general'
    | '/_auth/users/marketing'
    | '/_auth/users/permissions'
    | '/_auth/users/roles'
    | '/_auth/users/special'
    | '/_auth/users/view'
    | '/_auth/attendance/'
    | '/_auth/users/'
    | '/_auth/dashboards/dcr/$userId'
    | '/_auth/dashboards/system/$userId'
    | '/_auth/feedback/list/$feedbackId'
    | '/_auth/feedback/surveys/new'
    | '/_auth/geo-location/mo-travel-history/$userId'
    | '/_auth/hr-form/leave-applications/$applicationId'
    | '/_auth/market-promotion/approvals/$detailId'
    | '/_auth/market-promotion/publish-panel/new'
    | '/_auth/market-promotion/region-summary/donations'
    | '/_auth/pcmp/projects/new'
    | '/_auth/product/booklisted-institution/$projectId'
    | '/_auth/product/student-collection-projects/$projectId'
    | '/_auth/publish/batches/$batchId'
    | '/_auth/question/monitor/classes'
    | '/_auth/question/monitor/districts'
    | '/_auth/question/papers/$projectInstituteId'
    | '/_auth/settings/institute-submissions/$submissionId'
    | '/_auth/settings/institutes/create'
    | '/_auth/settings/institutes/user-mapping'
    | '/_auth/settings/teacher-inactivations/$requestId'
    | '/_auth/settings/teacher-submissions/$teacherId'
    | '/_auth/users/create/$category'
    | '/_auth/dashboards/dcr/'
    | '/_auth/dashboards/system/'
    | '/_auth/dashboards/zonal-statement/'
    | '/_auth/feedback/list/'
    | '/_auth/feedback/surveys/'
    | '/_auth/geo-location/mo-travel-history/'
    | '/_auth/hr-form/leave-applications/'
    | '/_auth/market-promotion/adjustment/'
    | '/_auth/market-promotion/approvals/'
    | '/_auth/market-promotion/publish-panel/'
    | '/_auth/market-promotion/region-summary/'
    | '/_auth/pcmp/accounts/'
    | '/_auth/pcmp/correction/'
    | '/_auth/pcmp/department-divisions/'
    | '/_auth/pcmp/disburse-verify/'
    | '/_auth/pcmp/edit-permissions/'
    | '/_auth/pcmp/marketing/'
    | '/_auth/pcmp/mis/'
    | '/_auth/pcmp/projects/'
    | '/_auth/pcmp/request-categories/'
    | '/_auth/pcmp/requests/'
    | '/_auth/product/booklisted-institution/'
    | '/_auth/product/specimen-distribution/'
    | '/_auth/product/student-collection-projects/'
    | '/_auth/promotion/adjustment/'
    | '/_auth/settings/institute-submissions/'
    | '/_auth/settings/institutes/'
    | '/_auth/settings/teacher-inactivations/'
    | '/_auth/settings/teacher-submissions/'
    | '/_auth/dashboards/zonal-statement/$userId/expense'
    | '/_auth/dashboards/zonal-statement/$userId/specimen'
    | '/_auth/feedback/surveys/$surveyId/edit'
    | '/_auth/market-promotion/adjustment/$promoItemId/$zmId'
    | '/_auth/market-promotion/publish-panel/batches/$batchId'
    | '/_auth/market-promotion/publish-panel/zonal-managers/$userId'
    | '/_auth/pcmp/projects/$projectId/created'
    | '/_auth/pcmp/projects/$projectId/edit'
    | '/_auth/product/specimen-distribution/$specimenId/$zmId'
    | '/_auth/promotion/adjustment/$promoItemId/$zmId'
    | '/_auth/question/monitor/institutes/$projectInstituteId'
    | '/_auth/settings/institutes/$instituteId/edit'
    | '/_print/pcmp/proposals/$proposalId/print'
    | '/_print/pcmp/reports/mis-status/print'
    | '/_print/pcmp/reports/mo-wise/print'
    | '/_print/pcmp/reports/pending/print'
    | '/_print/pcmp/reports/performance/print'
    | '/_auth/feedback/surveys/$surveyId/'
    | '/_auth/market-promotion/adjustment/$promoItemId/'
    | '/_auth/pcmp/projects/$projectId/'
    | '/_auth/pcmp/proposals/$proposalId/'
    | '/_auth/pcmp/reports/mis-status/'
    | '/_auth/pcmp/reports/mo-wise/'
    | '/_auth/pcmp/reports/pending/'
    | '/_auth/pcmp/reports/performance/'
    | '/_auth/pcmp/requests/requested/'
    | '/_auth/product/specimen-distribution/$specimenId/'
    | '/_auth/promotion/adjustment/$promoItemId/'
    | '/_auth/question/monitor/institutes/'
    | '/_auth/feedback/surveys/$surveyId/submissions/$submissionId'
    | '/_print/pcmp/accounts/batches/$batchNo/print'
    | '/_print/pcmp/accounts/redisburse-batches/$batchNo/print'
    | '/_print/pcmp/mis/batches/$batchNo/print'
    | '/_print/pcmp/requests/batches/$batchNo/print'
    | '/_auth/feedback/surveys/$surveyId/submissions/'
    | '/_auth/pcmp/accounts/batches/$batchNo/'
    | '/_auth/pcmp/accounts/redisburse-batches/$batchNo/'
    | '/_auth/pcmp/marketing/batches/$batchNo/'
    | '/_auth/pcmp/mis/batches/$batchNo/'
    | '/_auth/pcmp/requests/batches/$batchNo/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PrintRoute: typeof PrintRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  SsoRoute: typeof SsoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sso': {
      id: '/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof SsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_print': {
      id: '/_print'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/profile': {
      id: '/_auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/': {
      id: '/_auth/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/': {
      id: '/_auth/attendance/'
      path: '/attendance'
      fullPath: '/attendance/'
      preLoaderRoute: typeof AuthAttendanceIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/view': {
      id: '/_auth/users/view'
      path: '/users/view'
      fullPath: '/users/view'
      preLoaderRoute: typeof AuthUsersViewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/special': {
      id: '/_auth/users/special'
      path: '/users/special'
      fullPath: '/users/special'
      preLoaderRoute: typeof AuthUsersSpecialRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/roles': {
      id: '/_auth/users/roles'
      path: '/users/roles'
      fullPath: '/users/roles'
      preLoaderRoute: typeof AuthUsersRolesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/permissions': {
      id: '/_auth/users/permissions'
      path: '/users/permissions'
      fullPath: '/users/permissions'
      preLoaderRoute: typeof AuthUsersPermissionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/marketing': {
      id: '/_auth/users/marketing'
      path: '/users/marketing'
      fullPath: '/users/marketing'
      preLoaderRoute: typeof AuthUsersMarketingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/general': {
      id: '/_auth/users/general'
      path: '/users/general'
      fullPath: '/users/general'
      preLoaderRoute: typeof AuthUsersGeneralRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/edit': {
      id: '/_auth/users/edit'
      path: '/users/edit'
      fullPath: '/users/edit'
      preLoaderRoute: typeof AuthUsersEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/agent': {
      id: '/_auth/users/agent'
      path: '/users/agent'
      fullPath: '/users/agent'
      preLoaderRoute: typeof AuthUsersAgentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/admin': {
      id: '/_auth/users/admin'
      path: '/users/admin'
      fullPath: '/users/admin'
      preLoaderRoute: typeof AuthUsersAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/web-urls': {
      id: '/_auth/settings/web-urls'
      path: '/settings/web-urls'
      fullPath: '/settings/web-urls'
      preLoaderRoute: typeof AuthSettingsWebUrlsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/menu-labels': {
      id: '/_auth/settings/menu-labels'
      path: '/settings/menu-labels'
      fullPath: '/settings/menu-labels'
      preLoaderRoute: typeof AuthSettingsMenuLabelsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/limit-types': {
      id: '/_auth/settings/limit-types'
      path: '/settings/limit-types'
      fullPath: '/settings/limit-types'
      preLoaderRoute: typeof AuthSettingsLimitTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/leave-types': {
      id: '/_auth/settings/leave-types'
      path: '/settings/leave-types'
      fullPath: '/settings/leave-types'
      preLoaderRoute: typeof AuthSettingsLeaveTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institute-types': {
      id: '/_auth/settings/institute-types'
      path: '/settings/institute-types'
      fullPath: '/settings/institute-types'
      preLoaderRoute: typeof AuthSettingsInstituteTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/holidays': {
      id: '/_auth/settings/holidays'
      path: '/settings/holidays'
      fullPath: '/settings/holidays'
      preLoaderRoute: typeof AuthSettingsHolidaysRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/feedback-types': {
      id: '/_auth/settings/feedback-types'
      path: '/settings/feedback-types'
      fullPath: '/settings/feedback-types'
      preLoaderRoute: typeof AuthSettingsFeedbackTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/app-version-check': {
      id: '/_auth/reports/app-version-check'
      path: '/reports/app-version-check'
      fullPath: '/reports/app-version-check'
      preLoaderRoute: typeof AuthReportsAppVersionCheckRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/upload': {
      id: '/_auth/question/upload'
      path: '/question/upload'
      fullPath: '/question/upload'
      preLoaderRoute: typeof AuthQuestionUploadRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/subjects': {
      id: '/_auth/question/subjects'
      path: '/question/subjects'
      fullPath: '/question/subjects'
      preLoaderRoute: typeof AuthQuestionSubjectsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/projects': {
      id: '/_auth/question/projects'
      path: '/question/projects'
      fullPath: '/question/projects'
      preLoaderRoute: typeof AuthQuestionProjectsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/download-by-class': {
      id: '/_auth/question/download-by-class'
      path: '/question/download-by-class'
      fullPath: '/question/download-by-class'
      preLoaderRoute: typeof AuthQuestionDownloadByClassRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/download-by-board': {
      id: '/_auth/question/download-by-board'
      path: '/question/download-by-board'
      fullPath: '/question/download-by-board'
      preLoaderRoute: typeof AuthQuestionDownloadByBoardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/download': {
      id: '/_auth/question/download'
      path: '/question/download'
      fullPath: '/question/download'
      preLoaderRoute: typeof AuthQuestionDownloadRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/publish/sales': {
      id: '/_auth/publish/sales'
      path: '/publish/sales'
      fullPath: '/publish/sales'
      preLoaderRoute: typeof AuthPublishSalesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/publish/mis': {
      id: '/_auth/publish/mis'
      path: '/publish/mis'
      fullPath: '/publish/mis'
      preLoaderRoute: typeof AuthPublishMisRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/publish/accounts': {
      id: '/_auth/publish/accounts'
      path: '/publish/accounts'
      fullPath: '/publish/accounts'
      preLoaderRoute: typeof AuthPublishAccountsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/items': {
      id: '/_auth/promotion/items'
      path: '/promotion/items'
      fullPath: '/promotion/items'
      preLoaderRoute: typeof AuthPromotionItemsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/item-types': {
      id: '/_auth/promotion/item-types'
      path: '/promotion/item-types'
      fullPath: '/promotion/item-types'
      preLoaderRoute: typeof AuthPromotionItemTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/distribution': {
      id: '/_auth/promotion/distribution'
      path: '/promotion/distribution'
      fullPath: '/promotion/distribution'
      preLoaderRoute: typeof AuthPromotionDistributionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimens': {
      id: '/_auth/product/specimens'
      path: '/product/specimens'
      fullPath: '/product/specimens'
      preLoaderRoute: typeof AuthProductSpecimensRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-requisition-review': {
      id: '/_auth/product/specimen-requisition-review'
      path: '/product/specimen-requisition-review'
      fullPath: '/product/specimen-requisition-review'
      preLoaderRoute: typeof AuthProductSpecimenRequisitionReviewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-requisition': {
      id: '/_auth/product/specimen-requisition'
      path: '/product/specimen-requisition'
      fullPath: '/product/specimen-requisition'
      preLoaderRoute: typeof AuthProductSpecimenRequisitionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-list-view': {
      id: '/_auth/product/specimen-list-view'
      path: '/product/specimen-list-view'
      fullPath: '/product/specimen-list-view'
      preLoaderRoute: typeof AuthProductSpecimenListViewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-institution': {
      id: '/_auth/product/specimen-institution'
      path: '/product/specimen-institution'
      fullPath: '/product/specimen-institution'
      preLoaderRoute: typeof AuthProductSpecimenInstitutionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-adjustment': {
      id: '/_auth/product/specimen-adjustment'
      path: '/product/specimen-adjustment'
      fullPath: '/product/specimen-adjustment'
      preLoaderRoute: typeof AuthProductSpecimenAdjustmentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/sp-promotional-requisition': {
      id: '/_auth/product/sp-promotional-requisition'
      path: '/product/sp-promotional-requisition'
      fullPath: '/product/sp-promotional-requisition'
      preLoaderRoute: typeof AuthProductSpPromotionalRequisitionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/dcr-sheet': {
      id: '/_auth/product/dcr-sheet'
      path: '/product/dcr-sheet'
      fullPath: '/product/dcr-sheet'
      preLoaderRoute: typeof AuthProductDcrSheetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/dcr-date-to-date': {
      id: '/_auth/product/dcr-date-to-date'
      path: '/product/dcr-date-to-date'
      fullPath: '/product/dcr-date-to-date'
      preLoaderRoute: typeof AuthProductDcrDateToDateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/book-types': {
      id: '/_auth/product/book-types'
      path: '/product/book-types'
      fullPath: '/product/book-types'
      preLoaderRoute: typeof AuthProductBookTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/book-editions': {
      id: '/_auth/product/book-editions'
      path: '/product/book-editions'
      fullPath: '/product/book-editions'
      preLoaderRoute: typeof AuthProductBookEditionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/requisitions': {
      id: '/_auth/market-promotion/requisitions'
      path: '/market-promotion/requisitions'
      fullPath: '/market-promotion/requisitions'
      preLoaderRoute: typeof AuthMarketPromotionRequisitionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/projects': {
      id: '/_auth/market-promotion/projects'
      path: '/market-promotion/projects'
      fullPath: '/market-promotion/projects'
      preLoaderRoute: typeof AuthMarketPromotionProjectsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/mis-approvals': {
      id: '/_auth/market-promotion/mis-approvals'
      path: '/market-promotion/mis-approvals'
      fullPath: '/market-promotion/mis-approvals'
      preLoaderRoute: typeof AuthMarketPromotionMisApprovalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/distribution-summary': {
      id: '/_auth/market-promotion/distribution-summary'
      path: '/market-promotion/distribution-summary'
      fullPath: '/market-promotion/distribution-summary'
      preLoaderRoute: typeof AuthMarketPromotionDistributionSummaryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/cash-collection': {
      id: '/_auth/market-promotion/cash-collection'
      path: '/market-promotion/cash-collection'
      fullPath: '/market-promotion/cash-collection'
      preLoaderRoute: typeof AuthMarketPromotionCashCollectionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/budget-entry': {
      id: '/_auth/market-promotion/budget-entry'
      path: '/market-promotion/budget-entry'
      fullPath: '/market-promotion/budget-entry'
      preLoaderRoute: typeof AuthMarketPromotionBudgetEntryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/approval-report': {
      id: '/_auth/market-promotion/approval-report'
      path: '/market-promotion/approval-report'
      fullPath: '/market-promotion/approval-report'
      preLoaderRoute: typeof AuthMarketPromotionApprovalReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/accounts-adjust': {
      id: '/_auth/market-promotion/accounts-adjust'
      path: '/market-promotion/accounts-adjust'
      fullPath: '/market-promotion/accounts-adjust'
      preLoaderRoute: typeof AuthMarketPromotionAccountsAdjustRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hr-form/leave-report': {
      id: '/_auth/hr-form/leave-report'
      path: '/hr-form/leave-report'
      fullPath: '/hr-form/leave-report'
      preLoaderRoute: typeof AuthHrFormLeaveReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/types': {
      id: '/_auth/feedback/types'
      path: '/feedback/types'
      fullPath: '/feedback/types'
      preLoaderRoute: typeof AuthFeedbackTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/pending': {
      id: '/_auth/dashboards/pending'
      path: '/dashboards/pending'
      fullPath: '/dashboards/pending'
      preLoaderRoute: typeof AuthDashboardsPendingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/der': {
      id: '/_auth/dashboards/der'
      path: '/dashboards/der'
      fullPath: '/dashboards/der'
      preLoaderRoute: typeof AuthDashboardsDerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/web-expense': {
      id: '/_auth/billing/web-expense'
      path: '/billing/web-expense'
      fullPath: '/billing/web-expense'
      preLoaderRoute: typeof AuthBillingWebExpenseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/offline-der-verify': {
      id: '/_auth/billing/offline-der-verify'
      path: '/billing/offline-der-verify'
      fullPath: '/billing/offline-der-verify'
      preLoaderRoute: typeof AuthBillingOfflineDerVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/offline-dcr-verify': {
      id: '/_auth/billing/offline-dcr-verify'
      path: '/billing/offline-dcr-verify'
      fullPath: '/billing/offline-dcr-verify'
      preLoaderRoute: typeof AuthBillingOfflineDcrVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/expense-approve': {
      id: '/_auth/billing/expense-approve'
      path: '/billing/expense-approve'
      fullPath: '/billing/expense-approve'
      preLoaderRoute: typeof AuthBillingExpenseApproveRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/dcr-approve': {
      id: '/_auth/billing/dcr-approve'
      path: '/billing/dcr-approve'
      fullPath: '/billing/dcr-approve'
      preLoaderRoute: typeof AuthBillingDcrApproveRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/cost-amendment': {
      id: '/_auth/billing/cost-amendment'
      path: '/billing/cost-amendment'
      fullPath: '/billing/cost-amendment'
      preLoaderRoute: typeof AuthBillingCostAmendmentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/approval': {
      id: '/_auth/billing/approval'
      path: '/billing/approval'
      fullPath: '/billing/approval'
      preLoaderRoute: typeof AuthBillingApprovalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/all-cost': {
      id: '/_auth/billing/all-cost'
      path: '/billing/all-cost'
      fullPath: '/billing/all-cost'
      preLoaderRoute: typeof AuthBillingAllCostRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/shift-job-card': {
      id: '/_auth/attendance/shift-job-card'
      path: '/attendance/shift-job-card'
      fullPath: '/attendance/shift-job-card'
      preLoaderRoute: typeof AuthAttendanceShiftJobCardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/shift-employee-report': {
      id: '/_auth/attendance/shift-employee-report'
      path: '/attendance/shift-employee-report'
      fullPath: '/attendance/shift-employee-report'
      preLoaderRoute: typeof AuthAttendanceShiftEmployeeReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/job-card': {
      id: '/_auth/attendance/job-card'
      path: '/attendance/job-card'
      fullPath: '/attendance/job-card'
      preLoaderRoute: typeof AuthAttendanceJobCardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/employee-report': {
      id: '/_auth/attendance/employee-report'
      path: '/attendance/employee-report'
      fullPath: '/attendance/employee-report'
      preLoaderRoute: typeof AuthAttendanceEmployeeReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/teacher-submissions/': {
      id: '/_auth/settings/teacher-submissions/'
      path: '/settings/teacher-submissions'
      fullPath: '/settings/teacher-submissions/'
      preLoaderRoute: typeof AuthSettingsTeacherSubmissionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/teacher-inactivations/': {
      id: '/_auth/settings/teacher-inactivations/'
      path: '/settings/teacher-inactivations'
      fullPath: '/settings/teacher-inactivations/'
      preLoaderRoute: typeof AuthSettingsTeacherInactivationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institutes/': {
      id: '/_auth/settings/institutes/'
      path: '/settings/institutes'
      fullPath: '/settings/institutes/'
      preLoaderRoute: typeof AuthSettingsInstitutesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institute-submissions/': {
      id: '/_auth/settings/institute-submissions/'
      path: '/settings/institute-submissions'
      fullPath: '/settings/institute-submissions/'
      preLoaderRoute: typeof AuthSettingsInstituteSubmissionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/adjustment/': {
      id: '/_auth/promotion/adjustment/'
      path: '/promotion/adjustment'
      fullPath: '/promotion/adjustment/'
      preLoaderRoute: typeof AuthPromotionAdjustmentIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/student-collection-projects/': {
      id: '/_auth/product/student-collection-projects/'
      path: '/product/student-collection-projects'
      fullPath: '/product/student-collection-projects/'
      preLoaderRoute: typeof AuthProductStudentCollectionProjectsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-distribution/': {
      id: '/_auth/product/specimen-distribution/'
      path: '/product/specimen-distribution'
      fullPath: '/product/specimen-distribution/'
      preLoaderRoute: typeof AuthProductSpecimenDistributionIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/booklisted-institution/': {
      id: '/_auth/product/booklisted-institution/'
      path: '/product/booklisted-institution'
      fullPath: '/product/booklisted-institution/'
      preLoaderRoute: typeof AuthProductBooklistedInstitutionIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/requests/': {
      id: '/_auth/pcmp/requests/'
      path: '/pcmp/requests'
      fullPath: '/pcmp/requests/'
      preLoaderRoute: typeof AuthPcmpRequestsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/request-categories/': {
      id: '/_auth/pcmp/request-categories/'
      path: '/pcmp/request-categories'
      fullPath: '/pcmp/request-categories/'
      preLoaderRoute: typeof AuthPcmpRequestCategoriesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/projects/': {
      id: '/_auth/pcmp/projects/'
      path: '/pcmp/projects'
      fullPath: '/pcmp/projects/'
      preLoaderRoute: typeof AuthPcmpProjectsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/mis/': {
      id: '/_auth/pcmp/mis/'
      path: '/pcmp/mis'
      fullPath: '/pcmp/mis/'
      preLoaderRoute: typeof AuthPcmpMisIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/marketing/': {
      id: '/_auth/pcmp/marketing/'
      path: '/pcmp/marketing'
      fullPath: '/pcmp/marketing/'
      preLoaderRoute: typeof AuthPcmpMarketingIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/edit-permissions/': {
      id: '/_auth/pcmp/edit-permissions/'
      path: '/pcmp/edit-permissions'
      fullPath: '/pcmp/edit-permissions/'
      preLoaderRoute: typeof AuthPcmpEditPermissionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/disburse-verify/': {
      id: '/_auth/pcmp/disburse-verify/'
      path: '/pcmp/disburse-verify'
      fullPath: '/pcmp/disburse-verify/'
      preLoaderRoute: typeof AuthPcmpDisburseVerifyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/department-divisions/': {
      id: '/_auth/pcmp/department-divisions/'
      path: '/pcmp/department-divisions'
      fullPath: '/pcmp/department-divisions/'
      preLoaderRoute: typeof AuthPcmpDepartmentDivisionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/correction/': {
      id: '/_auth/pcmp/correction/'
      path: '/pcmp/correction'
      fullPath: '/pcmp/correction/'
      preLoaderRoute: typeof AuthPcmpCorrectionIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/accounts/': {
      id: '/_auth/pcmp/accounts/'
      path: '/pcmp/accounts'
      fullPath: '/pcmp/accounts/'
      preLoaderRoute: typeof AuthPcmpAccountsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/region-summary/': {
      id: '/_auth/market-promotion/region-summary/'
      path: '/market-promotion/region-summary'
      fullPath: '/market-promotion/region-summary/'
      preLoaderRoute: typeof AuthMarketPromotionRegionSummaryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/publish-panel/': {
      id: '/_auth/market-promotion/publish-panel/'
      path: '/market-promotion/publish-panel'
      fullPath: '/market-promotion/publish-panel/'
      preLoaderRoute: typeof AuthMarketPromotionPublishPanelIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/approvals/': {
      id: '/_auth/market-promotion/approvals/'
      path: '/market-promotion/approvals'
      fullPath: '/market-promotion/approvals/'
      preLoaderRoute: typeof AuthMarketPromotionApprovalsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/adjustment/': {
      id: '/_auth/market-promotion/adjustment/'
      path: '/market-promotion/adjustment'
      fullPath: '/market-promotion/adjustment/'
      preLoaderRoute: typeof AuthMarketPromotionAdjustmentIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hr-form/leave-applications/': {
      id: '/_auth/hr-form/leave-applications/'
      path: '/hr-form/leave-applications'
      fullPath: '/hr-form/leave-applications/'
      preLoaderRoute: typeof AuthHrFormLeaveApplicationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/geo-location/mo-travel-history/': {
      id: '/_auth/geo-location/mo-travel-history/'
      path: '/geo-location/mo-travel-history'
      fullPath: '/geo-location/mo-travel-history/'
      preLoaderRoute: typeof AuthGeoLocationMoTravelHistoryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/': {
      id: '/_auth/feedback/surveys/'
      path: '/feedback/surveys'
      fullPath: '/feedback/surveys/'
      preLoaderRoute: typeof AuthFeedbackSurveysIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/list/': {
      id: '/_auth/feedback/list/'
      path: '/feedback/list'
      fullPath: '/feedback/list/'
      preLoaderRoute: typeof AuthFeedbackListIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/zonal-statement/': {
      id: '/_auth/dashboards/zonal-statement/'
      path: '/dashboards/zonal-statement'
      fullPath: '/dashboards/zonal-statement/'
      preLoaderRoute: typeof AuthDashboardsZonalStatementIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/system/': {
      id: '/_auth/dashboards/system/'
      path: '/dashboards/system'
      fullPath: '/dashboards/system/'
      preLoaderRoute: typeof AuthDashboardsSystemIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/dcr/': {
      id: '/_auth/dashboards/dcr/'
      path: '/dashboards/dcr'
      fullPath: '/dashboards/dcr/'
      preLoaderRoute: typeof AuthDashboardsDcrIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/create/$category': {
      id: '/_auth/users/create/$category'
      path: '/users/create/$category'
      fullPath: '/users/create/$category'
      preLoaderRoute: typeof AuthUsersCreateCategoryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/teacher-submissions/$teacherId': {
      id: '/_auth/settings/teacher-submissions/$teacherId'
      path: '/settings/teacher-submissions/$teacherId'
      fullPath: '/settings/teacher-submissions/$teacherId'
      preLoaderRoute: typeof AuthSettingsTeacherSubmissionsTeacherIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/teacher-inactivations/$requestId': {
      id: '/_auth/settings/teacher-inactivations/$requestId'
      path: '/settings/teacher-inactivations/$requestId'
      fullPath: '/settings/teacher-inactivations/$requestId'
      preLoaderRoute: typeof AuthSettingsTeacherInactivationsRequestIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institutes/user-mapping': {
      id: '/_auth/settings/institutes/user-mapping'
      path: '/settings/institutes/user-mapping'
      fullPath: '/settings/institutes/user-mapping'
      preLoaderRoute: typeof AuthSettingsInstitutesUserMappingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institutes/create': {
      id: '/_auth/settings/institutes/create'
      path: '/settings/institutes/create'
      fullPath: '/settings/institutes/create'
      preLoaderRoute: typeof AuthSettingsInstitutesCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institute-submissions/$submissionId': {
      id: '/_auth/settings/institute-submissions/$submissionId'
      path: '/settings/institute-submissions/$submissionId'
      fullPath: '/settings/institute-submissions/$submissionId'
      preLoaderRoute: typeof AuthSettingsInstituteSubmissionsSubmissionIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/papers/$projectInstituteId': {
      id: '/_auth/question/papers/$projectInstituteId'
      path: '/question/papers/$projectInstituteId'
      fullPath: '/question/papers/$projectInstituteId'
      preLoaderRoute: typeof AuthQuestionPapersProjectInstituteIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/monitor/districts': {
      id: '/_auth/question/monitor/districts'
      path: '/question/monitor/districts'
      fullPath: '/question/monitor/districts'
      preLoaderRoute: typeof AuthQuestionMonitorDistrictsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/monitor/classes': {
      id: '/_auth/question/monitor/classes'
      path: '/question/monitor/classes'
      fullPath: '/question/monitor/classes'
      preLoaderRoute: typeof AuthQuestionMonitorClassesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/publish/batches/$batchId': {
      id: '/_auth/publish/batches/$batchId'
      path: '/publish/batches/$batchId'
      fullPath: '/publish/batches/$batchId'
      preLoaderRoute: typeof AuthPublishBatchesBatchIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/student-collection-projects/$projectId': {
      id: '/_auth/product/student-collection-projects/$projectId'
      path: '/product/student-collection-projects/$projectId'
      fullPath: '/product/student-collection-projects/$projectId'
      preLoaderRoute: typeof AuthProductStudentCollectionProjectsProjectIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/booklisted-institution/$projectId': {
      id: '/_auth/product/booklisted-institution/$projectId'
      path: '/product/booklisted-institution/$projectId'
      fullPath: '/product/booklisted-institution/$projectId'
      preLoaderRoute: typeof AuthProductBooklistedInstitutionProjectIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/projects/new': {
      id: '/_auth/pcmp/projects/new'
      path: '/pcmp/projects/new'
      fullPath: '/pcmp/projects/new'
      preLoaderRoute: typeof AuthPcmpProjectsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/region-summary/donations': {
      id: '/_auth/market-promotion/region-summary/donations'
      path: '/market-promotion/region-summary/donations'
      fullPath: '/market-promotion/region-summary/donations'
      preLoaderRoute: typeof AuthMarketPromotionRegionSummaryDonationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/publish-panel/new': {
      id: '/_auth/market-promotion/publish-panel/new'
      path: '/market-promotion/publish-panel/new'
      fullPath: '/market-promotion/publish-panel/new'
      preLoaderRoute: typeof AuthMarketPromotionPublishPanelNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/approvals/$detailId': {
      id: '/_auth/market-promotion/approvals/$detailId'
      path: '/market-promotion/approvals/$detailId'
      fullPath: '/market-promotion/approvals/$detailId'
      preLoaderRoute: typeof AuthMarketPromotionApprovalsDetailIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hr-form/leave-applications/$applicationId': {
      id: '/_auth/hr-form/leave-applications/$applicationId'
      path: '/hr-form/leave-applications/$applicationId'
      fullPath: '/hr-form/leave-applications/$applicationId'
      preLoaderRoute: typeof AuthHrFormLeaveApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/geo-location/mo-travel-history/$userId': {
      id: '/_auth/geo-location/mo-travel-history/$userId'
      path: '/geo-location/mo-travel-history/$userId'
      fullPath: '/geo-location/mo-travel-history/$userId'
      preLoaderRoute: typeof AuthGeoLocationMoTravelHistoryUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/new': {
      id: '/_auth/feedback/surveys/new'
      path: '/feedback/surveys/new'
      fullPath: '/feedback/surveys/new'
      preLoaderRoute: typeof AuthFeedbackSurveysNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/list/$feedbackId': {
      id: '/_auth/feedback/list/$feedbackId'
      path: '/feedback/list/$feedbackId'
      fullPath: '/feedback/list/$feedbackId'
      preLoaderRoute: typeof AuthFeedbackListFeedbackIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/system/$userId': {
      id: '/_auth/dashboards/system/$userId'
      path: '/dashboards/system/$userId'
      fullPath: '/dashboards/system/$userId'
      preLoaderRoute: typeof AuthDashboardsSystemUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/dcr/$userId': {
      id: '/_auth/dashboards/dcr/$userId'
      path: '/dashboards/dcr/$userId'
      fullPath: '/dashboards/dcr/$userId'
      preLoaderRoute: typeof AuthDashboardsDcrUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/monitor/institutes/': {
      id: '/_auth/question/monitor/institutes/'
      path: '/question/monitor/institutes'
      fullPath: '/question/monitor/institutes/'
      preLoaderRoute: typeof AuthQuestionMonitorInstitutesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/adjustment/$promoItemId/': {
      id: '/_auth/promotion/adjustment/$promoItemId/'
      path: '/promotion/adjustment/$promoItemId'
      fullPath: '/promotion/adjustment/$promoItemId/'
      preLoaderRoute: typeof AuthPromotionAdjustmentPromoItemIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-distribution/$specimenId/': {
      id: '/_auth/product/specimen-distribution/$specimenId/'
      path: '/product/specimen-distribution/$specimenId'
      fullPath: '/product/specimen-distribution/$specimenId/'
      preLoaderRoute: typeof AuthProductSpecimenDistributionSpecimenIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/requests/requested/': {
      id: '/_auth/pcmp/requests/requested/'
      path: '/pcmp/requests/requested'
      fullPath: '/pcmp/requests/requested/'
      preLoaderRoute: typeof AuthPcmpRequestsRequestedIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/reports/performance/': {
      id: '/_auth/pcmp/reports/performance/'
      path: '/pcmp/reports/performance'
      fullPath: '/pcmp/reports/performance/'
      preLoaderRoute: typeof AuthPcmpReportsPerformanceIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/reports/pending/': {
      id: '/_auth/pcmp/reports/pending/'
      path: '/pcmp/reports/pending'
      fullPath: '/pcmp/reports/pending/'
      preLoaderRoute: typeof AuthPcmpReportsPendingIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/reports/mo-wise/': {
      id: '/_auth/pcmp/reports/mo-wise/'
      path: '/pcmp/reports/mo-wise'
      fullPath: '/pcmp/reports/mo-wise/'
      preLoaderRoute: typeof AuthPcmpReportsMoWiseIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/reports/mis-status/': {
      id: '/_auth/pcmp/reports/mis-status/'
      path: '/pcmp/reports/mis-status'
      fullPath: '/pcmp/reports/mis-status/'
      preLoaderRoute: typeof AuthPcmpReportsMisStatusIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/proposals/$proposalId/': {
      id: '/_auth/pcmp/proposals/$proposalId/'
      path: '/pcmp/proposals/$proposalId'
      fullPath: '/pcmp/proposals/$proposalId/'
      preLoaderRoute: typeof AuthPcmpProposalsProposalIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/projects/$projectId/': {
      id: '/_auth/pcmp/projects/$projectId/'
      path: '/pcmp/projects/$projectId'
      fullPath: '/pcmp/projects/$projectId/'
      preLoaderRoute: typeof AuthPcmpProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/adjustment/$promoItemId/': {
      id: '/_auth/market-promotion/adjustment/$promoItemId/'
      path: '/market-promotion/adjustment/$promoItemId'
      fullPath: '/market-promotion/adjustment/$promoItemId/'
      preLoaderRoute: typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/$surveyId/': {
      id: '/_auth/feedback/surveys/$surveyId/'
      path: '/feedback/surveys/$surveyId'
      fullPath: '/feedback/surveys/$surveyId/'
      preLoaderRoute: typeof AuthFeedbackSurveysSurveyIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_print/pcmp/reports/performance/print': {
      id: '/_print/pcmp/reports/performance/print'
      path: '/pcmp/reports/performance/print'
      fullPath: '/pcmp/reports/performance/print'
      preLoaderRoute: typeof PrintPcmpReportsPerformancePrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_print/pcmp/reports/pending/print': {
      id: '/_print/pcmp/reports/pending/print'
      path: '/pcmp/reports/pending/print'
      fullPath: '/pcmp/reports/pending/print'
      preLoaderRoute: typeof PrintPcmpReportsPendingPrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_print/pcmp/reports/mo-wise/print': {
      id: '/_print/pcmp/reports/mo-wise/print'
      path: '/pcmp/reports/mo-wise/print'
      fullPath: '/pcmp/reports/mo-wise/print'
      preLoaderRoute: typeof PrintPcmpReportsMoWisePrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_print/pcmp/reports/mis-status/print': {
      id: '/_print/pcmp/reports/mis-status/print'
      path: '/pcmp/reports/mis-status/print'
      fullPath: '/pcmp/reports/mis-status/print'
      preLoaderRoute: typeof PrintPcmpReportsMisStatusPrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_print/pcmp/proposals/$proposalId/print': {
      id: '/_print/pcmp/proposals/$proposalId/print'
      path: '/pcmp/proposals/$proposalId/print'
      fullPath: '/pcmp/proposals/$proposalId/print'
      preLoaderRoute: typeof PrintPcmpProposalsProposalIdPrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_auth/settings/institutes/$instituteId/edit': {
      id: '/_auth/settings/institutes/$instituteId/edit'
      path: '/settings/institutes/$instituteId/edit'
      fullPath: '/settings/institutes/$instituteId/edit'
      preLoaderRoute: typeof AuthSettingsInstitutesInstituteIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/monitor/institutes/$projectInstituteId': {
      id: '/_auth/question/monitor/institutes/$projectInstituteId'
      path: '/question/monitor/institutes/$projectInstituteId'
      fullPath: '/question/monitor/institutes/$projectInstituteId'
      preLoaderRoute: typeof AuthQuestionMonitorInstitutesProjectInstituteIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/adjustment/$promoItemId/$zmId': {
      id: '/_auth/promotion/adjustment/$promoItemId/$zmId'
      path: '/promotion/adjustment/$promoItemId/$zmId'
      fullPath: '/promotion/adjustment/$promoItemId/$zmId'
      preLoaderRoute: typeof AuthPromotionAdjustmentPromoItemIdZmIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-distribution/$specimenId/$zmId': {
      id: '/_auth/product/specimen-distribution/$specimenId/$zmId'
      path: '/product/specimen-distribution/$specimenId/$zmId'
      fullPath: '/product/specimen-distribution/$specimenId/$zmId'
      preLoaderRoute: typeof AuthProductSpecimenDistributionSpecimenIdZmIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/projects/$projectId/edit': {
      id: '/_auth/pcmp/projects/$projectId/edit'
      path: '/pcmp/projects/$projectId/edit'
      fullPath: '/pcmp/projects/$projectId/edit'
      preLoaderRoute: typeof AuthPcmpProjectsProjectIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/projects/$projectId/created': {
      id: '/_auth/pcmp/projects/$projectId/created'
      path: '/pcmp/projects/$projectId/created'
      fullPath: '/pcmp/projects/$projectId/created'
      preLoaderRoute: typeof AuthPcmpProjectsProjectIdCreatedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/publish-panel/zonal-managers/$userId': {
      id: '/_auth/market-promotion/publish-panel/zonal-managers/$userId'
      path: '/market-promotion/publish-panel/zonal-managers/$userId'
      fullPath: '/market-promotion/publish-panel/zonal-managers/$userId'
      preLoaderRoute: typeof AuthMarketPromotionPublishPanelZonalManagersUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/publish-panel/batches/$batchId': {
      id: '/_auth/market-promotion/publish-panel/batches/$batchId'
      path: '/market-promotion/publish-panel/batches/$batchId'
      fullPath: '/market-promotion/publish-panel/batches/$batchId'
      preLoaderRoute: typeof AuthMarketPromotionPublishPanelBatchesBatchIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/adjustment/$promoItemId/$zmId': {
      id: '/_auth/market-promotion/adjustment/$promoItemId/$zmId'
      path: '/market-promotion/adjustment/$promoItemId/$zmId'
      fullPath: '/market-promotion/adjustment/$promoItemId/$zmId'
      preLoaderRoute: typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/$surveyId/edit': {
      id: '/_auth/feedback/surveys/$surveyId/edit'
      path: '/feedback/surveys/$surveyId/edit'
      fullPath: '/feedback/surveys/$surveyId/edit'
      preLoaderRoute: typeof AuthFeedbackSurveysSurveyIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/zonal-statement/$userId/specimen': {
      id: '/_auth/dashboards/zonal-statement/$userId/specimen'
      path: '/dashboards/zonal-statement/$userId/specimen'
      fullPath: '/dashboards/zonal-statement/$userId/specimen'
      preLoaderRoute: typeof AuthDashboardsZonalStatementUserIdSpecimenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/zonal-statement/$userId/expense': {
      id: '/_auth/dashboards/zonal-statement/$userId/expense'
      path: '/dashboards/zonal-statement/$userId/expense'
      fullPath: '/dashboards/zonal-statement/$userId/expense'
      preLoaderRoute: typeof AuthDashboardsZonalStatementUserIdExpenseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/requests/batches/$batchNo/': {
      id: '/_auth/pcmp/requests/batches/$batchNo/'
      path: '/pcmp/requests/batches/$batchNo'
      fullPath: '/pcmp/requests/batches/$batchNo/'
      preLoaderRoute: typeof AuthPcmpRequestsBatchesBatchNoIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/mis/batches/$batchNo/': {
      id: '/_auth/pcmp/mis/batches/$batchNo/'
      path: '/pcmp/mis/batches/$batchNo'
      fullPath: '/pcmp/mis/batches/$batchNo/'
      preLoaderRoute: typeof AuthPcmpMisBatchesBatchNoIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/marketing/batches/$batchNo/': {
      id: '/_auth/pcmp/marketing/batches/$batchNo/'
      path: '/pcmp/marketing/batches/$batchNo'
      fullPath: '/pcmp/marketing/batches/$batchNo/'
      preLoaderRoute: typeof AuthPcmpMarketingBatchesBatchNoIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/accounts/redisburse-batches/$batchNo/': {
      id: '/_auth/pcmp/accounts/redisburse-batches/$batchNo/'
      path: '/pcmp/accounts/redisburse-batches/$batchNo'
      fullPath: '/pcmp/accounts/redisburse-batches/$batchNo/'
      preLoaderRoute: typeof AuthPcmpAccountsRedisburseBatchesBatchNoIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pcmp/accounts/batches/$batchNo/': {
      id: '/_auth/pcmp/accounts/batches/$batchNo/'
      path: '/pcmp/accounts/batches/$batchNo'
      fullPath: '/pcmp/accounts/batches/$batchNo/'
      preLoaderRoute: typeof AuthPcmpAccountsBatchesBatchNoIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/$surveyId/submissions/': {
      id: '/_auth/feedback/surveys/$surveyId/submissions/'
      path: '/feedback/surveys/$surveyId/submissions'
      fullPath: '/feedback/surveys/$surveyId/submissions/'
      preLoaderRoute: typeof AuthFeedbackSurveysSurveyIdSubmissionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_print/pcmp/requests/batches/$batchNo/print': {
      id: '/_print/pcmp/requests/batches/$batchNo/print'
      path: '/pcmp/requests/batches/$batchNo/print'
      fullPath: '/pcmp/requests/batches/$batchNo/print'
      preLoaderRoute: typeof PrintPcmpRequestsBatchesBatchNoPrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_print/pcmp/mis/batches/$batchNo/print': {
      id: '/_print/pcmp/mis/batches/$batchNo/print'
      path: '/pcmp/mis/batches/$batchNo/print'
      fullPath: '/pcmp/mis/batches/$batchNo/print'
      preLoaderRoute: typeof PrintPcmpMisBatchesBatchNoPrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_print/pcmp/accounts/redisburse-batches/$batchNo/print': {
      id: '/_print/pcmp/accounts/redisburse-batches/$batchNo/print'
      path: '/pcmp/accounts/redisburse-batches/$batchNo/print'
      fullPath: '/pcmp/accounts/redisburse-batches/$batchNo/print'
      preLoaderRoute: typeof PrintPcmpAccountsRedisburseBatchesBatchNoPrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_print/pcmp/accounts/batches/$batchNo/print': {
      id: '/_print/pcmp/accounts/batches/$batchNo/print'
      path: '/pcmp/accounts/batches/$batchNo/print'
      fullPath: '/pcmp/accounts/batches/$batchNo/print'
      preLoaderRoute: typeof PrintPcmpAccountsBatchesBatchNoPrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_auth/feedback/surveys/$surveyId/submissions/$submissionId': {
      id: '/_auth/feedback/surveys/$surveyId/submissions/$submissionId'
      path: '/feedback/surveys/$surveyId/submissions/$submissionId'
      fullPath: '/feedback/surveys/$surveyId/submissions/$submissionId'
      preLoaderRoute: typeof AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthProfileRoute: typeof AuthProfileRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAttendanceEmployeeReportRoute: typeof AuthAttendanceEmployeeReportRoute
  AuthAttendanceJobCardRoute: typeof AuthAttendanceJobCardRoute
  AuthAttendanceShiftEmployeeReportRoute: typeof AuthAttendanceShiftEmployeeReportRoute
  AuthAttendanceShiftJobCardRoute: typeof AuthAttendanceShiftJobCardRoute
  AuthBillingAllCostRoute: typeof AuthBillingAllCostRoute
  AuthBillingApprovalRoute: typeof AuthBillingApprovalRoute
  AuthBillingCostAmendmentRoute: typeof AuthBillingCostAmendmentRoute
  AuthBillingDcrApproveRoute: typeof AuthBillingDcrApproveRoute
  AuthBillingExpenseApproveRoute: typeof AuthBillingExpenseApproveRoute
  AuthBillingOfflineDcrVerifyRoute: typeof AuthBillingOfflineDcrVerifyRoute
  AuthBillingOfflineDerVerifyRoute: typeof AuthBillingOfflineDerVerifyRoute
  AuthBillingWebExpenseRoute: typeof AuthBillingWebExpenseRoute
  AuthDashboardsDerRoute: typeof AuthDashboardsDerRoute
  AuthDashboardsPendingRoute: typeof AuthDashboardsPendingRoute
  AuthFeedbackTypesRoute: typeof AuthFeedbackTypesRoute
  AuthHrFormLeaveReportRoute: typeof AuthHrFormLeaveReportRoute
  AuthMarketPromotionAccountsAdjustRoute: typeof AuthMarketPromotionAccountsAdjustRoute
  AuthMarketPromotionApprovalReportRoute: typeof AuthMarketPromotionApprovalReportRoute
  AuthMarketPromotionBudgetEntryRoute: typeof AuthMarketPromotionBudgetEntryRoute
  AuthMarketPromotionCashCollectionRoute: typeof AuthMarketPromotionCashCollectionRoute
  AuthMarketPromotionDistributionSummaryRoute: typeof AuthMarketPromotionDistributionSummaryRoute
  AuthMarketPromotionMisApprovalsRoute: typeof AuthMarketPromotionMisApprovalsRoute
  AuthMarketPromotionProjectsRoute: typeof AuthMarketPromotionProjectsRoute
  AuthMarketPromotionRequisitionsRoute: typeof AuthMarketPromotionRequisitionsRoute
  AuthProductBookEditionsRoute: typeof AuthProductBookEditionsRoute
  AuthProductBookTypesRoute: typeof AuthProductBookTypesRoute
  AuthProductDcrDateToDateRoute: typeof AuthProductDcrDateToDateRoute
  AuthProductDcrSheetRoute: typeof AuthProductDcrSheetRoute
  AuthProductSpPromotionalRequisitionRoute: typeof AuthProductSpPromotionalRequisitionRoute
  AuthProductSpecimenAdjustmentRoute: typeof AuthProductSpecimenAdjustmentRoute
  AuthProductSpecimenInstitutionRoute: typeof AuthProductSpecimenInstitutionRoute
  AuthProductSpecimenListViewRoute: typeof AuthProductSpecimenListViewRoute
  AuthProductSpecimenRequisitionRoute: typeof AuthProductSpecimenRequisitionRoute
  AuthProductSpecimenRequisitionReviewRoute: typeof AuthProductSpecimenRequisitionReviewRoute
  AuthProductSpecimensRoute: typeof AuthProductSpecimensRoute
  AuthPromotionDistributionRoute: typeof AuthPromotionDistributionRoute
  AuthPromotionItemTypesRoute: typeof AuthPromotionItemTypesRoute
  AuthPromotionItemsRoute: typeof AuthPromotionItemsRoute
  AuthPublishAccountsRoute: typeof AuthPublishAccountsRoute
  AuthPublishMisRoute: typeof AuthPublishMisRoute
  AuthPublishSalesRoute: typeof AuthPublishSalesRoute
  AuthQuestionDownloadRoute: typeof AuthQuestionDownloadRoute
  AuthQuestionDownloadByBoardRoute: typeof AuthQuestionDownloadByBoardRoute
  AuthQuestionDownloadByClassRoute: typeof AuthQuestionDownloadByClassRoute
  AuthQuestionProjectsRoute: typeof AuthQuestionProjectsRoute
  AuthQuestionSubjectsRoute: typeof AuthQuestionSubjectsRoute
  AuthQuestionUploadRoute: typeof AuthQuestionUploadRoute
  AuthReportsAppVersionCheckRoute: typeof AuthReportsAppVersionCheckRoute
  AuthSettingsFeedbackTypesRoute: typeof AuthSettingsFeedbackTypesRoute
  AuthSettingsHolidaysRoute: typeof AuthSettingsHolidaysRoute
  AuthSettingsInstituteTypesRoute: typeof AuthSettingsInstituteTypesRoute
  AuthSettingsLeaveTypesRoute: typeof AuthSettingsLeaveTypesRoute
  AuthSettingsLimitTypesRoute: typeof AuthSettingsLimitTypesRoute
  AuthSettingsMenuLabelsRoute: typeof AuthSettingsMenuLabelsRoute
  AuthSettingsWebUrlsRoute: typeof AuthSettingsWebUrlsRoute
  AuthUsersAdminRoute: typeof AuthUsersAdminRoute
  AuthUsersAgentRoute: typeof AuthUsersAgentRoute
  AuthUsersEditRoute: typeof AuthUsersEditRoute
  AuthUsersGeneralRoute: typeof AuthUsersGeneralRoute
  AuthUsersMarketingRoute: typeof AuthUsersMarketingRoute
  AuthUsersPermissionsRoute: typeof AuthUsersPermissionsRoute
  AuthUsersRolesRoute: typeof AuthUsersRolesRoute
  AuthUsersSpecialRoute: typeof AuthUsersSpecialRoute
  AuthUsersViewRoute: typeof AuthUsersViewRoute
  AuthAttendanceIndexRoute: typeof AuthAttendanceIndexRoute
  AuthUsersIndexRoute: typeof AuthUsersIndexRoute
  AuthDashboardsDcrUserIdRoute: typeof AuthDashboardsDcrUserIdRoute
  AuthDashboardsSystemUserIdRoute: typeof AuthDashboardsSystemUserIdRoute
  AuthFeedbackListFeedbackIdRoute: typeof AuthFeedbackListFeedbackIdRoute
  AuthFeedbackSurveysNewRoute: typeof AuthFeedbackSurveysNewRoute
  AuthGeoLocationMoTravelHistoryUserIdRoute: typeof AuthGeoLocationMoTravelHistoryUserIdRoute
  AuthHrFormLeaveApplicationsApplicationIdRoute: typeof AuthHrFormLeaveApplicationsApplicationIdRoute
  AuthMarketPromotionApprovalsDetailIdRoute: typeof AuthMarketPromotionApprovalsDetailIdRoute
  AuthMarketPromotionPublishPanelNewRoute: typeof AuthMarketPromotionPublishPanelNewRoute
  AuthMarketPromotionRegionSummaryDonationsRoute: typeof AuthMarketPromotionRegionSummaryDonationsRoute
  AuthPcmpProjectsNewRoute: typeof AuthPcmpProjectsNewRoute
  AuthProductBooklistedInstitutionProjectIdRoute: typeof AuthProductBooklistedInstitutionProjectIdRoute
  AuthProductStudentCollectionProjectsProjectIdRoute: typeof AuthProductStudentCollectionProjectsProjectIdRoute
  AuthPublishBatchesBatchIdRoute: typeof AuthPublishBatchesBatchIdRoute
  AuthQuestionMonitorClassesRoute: typeof AuthQuestionMonitorClassesRoute
  AuthQuestionMonitorDistrictsRoute: typeof AuthQuestionMonitorDistrictsRoute
  AuthQuestionPapersProjectInstituteIdRoute: typeof AuthQuestionPapersProjectInstituteIdRoute
  AuthSettingsInstituteSubmissionsSubmissionIdRoute: typeof AuthSettingsInstituteSubmissionsSubmissionIdRoute
  AuthSettingsInstitutesCreateRoute: typeof AuthSettingsInstitutesCreateRoute
  AuthSettingsInstitutesUserMappingRoute: typeof AuthSettingsInstitutesUserMappingRoute
  AuthSettingsTeacherInactivationsRequestIdRoute: typeof AuthSettingsTeacherInactivationsRequestIdRoute
  AuthSettingsTeacherSubmissionsTeacherIdRoute: typeof AuthSettingsTeacherSubmissionsTeacherIdRoute
  AuthUsersCreateCategoryRoute: typeof AuthUsersCreateCategoryRoute
  AuthDashboardsDcrIndexRoute: typeof AuthDashboardsDcrIndexRoute
  AuthDashboardsSystemIndexRoute: typeof AuthDashboardsSystemIndexRoute
  AuthDashboardsZonalStatementIndexRoute: typeof AuthDashboardsZonalStatementIndexRoute
  AuthFeedbackListIndexRoute: typeof AuthFeedbackListIndexRoute
  AuthFeedbackSurveysIndexRoute: typeof AuthFeedbackSurveysIndexRoute
  AuthGeoLocationMoTravelHistoryIndexRoute: typeof AuthGeoLocationMoTravelHistoryIndexRoute
  AuthHrFormLeaveApplicationsIndexRoute: typeof AuthHrFormLeaveApplicationsIndexRoute
  AuthMarketPromotionAdjustmentIndexRoute: typeof AuthMarketPromotionAdjustmentIndexRoute
  AuthMarketPromotionApprovalsIndexRoute: typeof AuthMarketPromotionApprovalsIndexRoute
  AuthMarketPromotionPublishPanelIndexRoute: typeof AuthMarketPromotionPublishPanelIndexRoute
  AuthMarketPromotionRegionSummaryIndexRoute: typeof AuthMarketPromotionRegionSummaryIndexRoute
  AuthPcmpAccountsIndexRoute: typeof AuthPcmpAccountsIndexRoute
  AuthPcmpCorrectionIndexRoute: typeof AuthPcmpCorrectionIndexRoute
  AuthPcmpDepartmentDivisionsIndexRoute: typeof AuthPcmpDepartmentDivisionsIndexRoute
  AuthPcmpDisburseVerifyIndexRoute: typeof AuthPcmpDisburseVerifyIndexRoute
  AuthPcmpEditPermissionsIndexRoute: typeof AuthPcmpEditPermissionsIndexRoute
  AuthPcmpMarketingIndexRoute: typeof AuthPcmpMarketingIndexRoute
  AuthPcmpMisIndexRoute: typeof AuthPcmpMisIndexRoute
  AuthPcmpProjectsIndexRoute: typeof AuthPcmpProjectsIndexRoute
  AuthPcmpRequestCategoriesIndexRoute: typeof AuthPcmpRequestCategoriesIndexRoute
  AuthPcmpRequestsIndexRoute: typeof AuthPcmpRequestsIndexRoute
  AuthProductBooklistedInstitutionIndexRoute: typeof AuthProductBooklistedInstitutionIndexRoute
  AuthProductSpecimenDistributionIndexRoute: typeof AuthProductSpecimenDistributionIndexRoute
  AuthProductStudentCollectionProjectsIndexRoute: typeof AuthProductStudentCollectionProjectsIndexRoute
  AuthPromotionAdjustmentIndexRoute: typeof AuthPromotionAdjustmentIndexRoute
  AuthSettingsInstituteSubmissionsIndexRoute: typeof AuthSettingsInstituteSubmissionsIndexRoute
  AuthSettingsInstitutesIndexRoute: typeof AuthSettingsInstitutesIndexRoute
  AuthSettingsTeacherInactivationsIndexRoute: typeof AuthSettingsTeacherInactivationsIndexRoute
  AuthSettingsTeacherSubmissionsIndexRoute: typeof AuthSettingsTeacherSubmissionsIndexRoute
  AuthDashboardsZonalStatementUserIdExpenseRoute: typeof AuthDashboardsZonalStatementUserIdExpenseRoute
  AuthDashboardsZonalStatementUserIdSpecimenRoute: typeof AuthDashboardsZonalStatementUserIdSpecimenRoute
  AuthFeedbackSurveysSurveyIdEditRoute: typeof AuthFeedbackSurveysSurveyIdEditRoute
  AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute: typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute
  AuthMarketPromotionPublishPanelBatchesBatchIdRoute: typeof AuthMarketPromotionPublishPanelBatchesBatchIdRoute
  AuthMarketPromotionPublishPanelZonalManagersUserIdRoute: typeof AuthMarketPromotionPublishPanelZonalManagersUserIdRoute
  AuthPcmpProjectsProjectIdCreatedRoute: typeof AuthPcmpProjectsProjectIdCreatedRoute
  AuthPcmpProjectsProjectIdEditRoute: typeof AuthPcmpProjectsProjectIdEditRoute
  AuthProductSpecimenDistributionSpecimenIdZmIdRoute: typeof AuthProductSpecimenDistributionSpecimenIdZmIdRoute
  AuthPromotionAdjustmentPromoItemIdZmIdRoute: typeof AuthPromotionAdjustmentPromoItemIdZmIdRoute
  AuthQuestionMonitorInstitutesProjectInstituteIdRoute: typeof AuthQuestionMonitorInstitutesProjectInstituteIdRoute
  AuthSettingsInstitutesInstituteIdEditRoute: typeof AuthSettingsInstitutesInstituteIdEditRoute
  AuthFeedbackSurveysSurveyIdIndexRoute: typeof AuthFeedbackSurveysSurveyIdIndexRoute
  AuthMarketPromotionAdjustmentPromoItemIdIndexRoute: typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRoute
  AuthPcmpProjectsProjectIdIndexRoute: typeof AuthPcmpProjectsProjectIdIndexRoute
  AuthPcmpProposalsProposalIdIndexRoute: typeof AuthPcmpProposalsProposalIdIndexRoute
  AuthPcmpReportsMisStatusIndexRoute: typeof AuthPcmpReportsMisStatusIndexRoute
  AuthPcmpReportsMoWiseIndexRoute: typeof AuthPcmpReportsMoWiseIndexRoute
  AuthPcmpReportsPendingIndexRoute: typeof AuthPcmpReportsPendingIndexRoute
  AuthPcmpReportsPerformanceIndexRoute: typeof AuthPcmpReportsPerformanceIndexRoute
  AuthPcmpRequestsRequestedIndexRoute: typeof AuthPcmpRequestsRequestedIndexRoute
  AuthProductSpecimenDistributionSpecimenIdIndexRoute: typeof AuthProductSpecimenDistributionSpecimenIdIndexRoute
  AuthPromotionAdjustmentPromoItemIdIndexRoute: typeof AuthPromotionAdjustmentPromoItemIdIndexRoute
  AuthQuestionMonitorInstitutesIndexRoute: typeof AuthQuestionMonitorInstitutesIndexRoute
  AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRoute: typeof AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRoute
  AuthFeedbackSurveysSurveyIdSubmissionsIndexRoute: typeof AuthFeedbackSurveysSurveyIdSubmissionsIndexRoute
  AuthPcmpAccountsBatchesBatchNoIndexRoute: typeof AuthPcmpAccountsBatchesBatchNoIndexRoute
  AuthPcmpAccountsRedisburseBatchesBatchNoIndexRoute: typeof AuthPcmpAccountsRedisburseBatchesBatchNoIndexRoute
  AuthPcmpMarketingBatchesBatchNoIndexRoute: typeof AuthPcmpMarketingBatchesBatchNoIndexRoute
  AuthPcmpMisBatchesBatchNoIndexRoute: typeof AuthPcmpMisBatchesBatchNoIndexRoute
  AuthPcmpRequestsBatchesBatchNoIndexRoute: typeof AuthPcmpRequestsBatchesBatchNoIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthProfileRoute: AuthProfileRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAttendanceEmployeeReportRoute: AuthAttendanceEmployeeReportRoute,
  AuthAttendanceJobCardRoute: AuthAttendanceJobCardRoute,
  AuthAttendanceShiftEmployeeReportRoute:
    AuthAttendanceShiftEmployeeReportRoute,
  AuthAttendanceShiftJobCardRoute: AuthAttendanceShiftJobCardRoute,
  AuthBillingAllCostRoute: AuthBillingAllCostRoute,
  AuthBillingApprovalRoute: AuthBillingApprovalRoute,
  AuthBillingCostAmendmentRoute: AuthBillingCostAmendmentRoute,
  AuthBillingDcrApproveRoute: AuthBillingDcrApproveRoute,
  AuthBillingExpenseApproveRoute: AuthBillingExpenseApproveRoute,
  AuthBillingOfflineDcrVerifyRoute: AuthBillingOfflineDcrVerifyRoute,
  AuthBillingOfflineDerVerifyRoute: AuthBillingOfflineDerVerifyRoute,
  AuthBillingWebExpenseRoute: AuthBillingWebExpenseRoute,
  AuthDashboardsDerRoute: AuthDashboardsDerRoute,
  AuthDashboardsPendingRoute: AuthDashboardsPendingRoute,
  AuthFeedbackTypesRoute: AuthFeedbackTypesRoute,
  AuthHrFormLeaveReportRoute: AuthHrFormLeaveReportRoute,
  AuthMarketPromotionAccountsAdjustRoute:
    AuthMarketPromotionAccountsAdjustRoute,
  AuthMarketPromotionApprovalReportRoute:
    AuthMarketPromotionApprovalReportRoute,
  AuthMarketPromotionBudgetEntryRoute: AuthMarketPromotionBudgetEntryRoute,
  AuthMarketPromotionCashCollectionRoute:
    AuthMarketPromotionCashCollectionRoute,
  AuthMarketPromotionDistributionSummaryRoute:
    AuthMarketPromotionDistributionSummaryRoute,
  AuthMarketPromotionMisApprovalsRoute: AuthMarketPromotionMisApprovalsRoute,
  AuthMarketPromotionProjectsRoute: AuthMarketPromotionProjectsRoute,
  AuthMarketPromotionRequisitionsRoute: AuthMarketPromotionRequisitionsRoute,
  AuthProductBookEditionsRoute: AuthProductBookEditionsRoute,
  AuthProductBookTypesRoute: AuthProductBookTypesRoute,
  AuthProductDcrDateToDateRoute: AuthProductDcrDateToDateRoute,
  AuthProductDcrSheetRoute: AuthProductDcrSheetRoute,
  AuthProductSpPromotionalRequisitionRoute:
    AuthProductSpPromotionalRequisitionRoute,
  AuthProductSpecimenAdjustmentRoute: AuthProductSpecimenAdjustmentRoute,
  AuthProductSpecimenInstitutionRoute: AuthProductSpecimenInstitutionRoute,
  AuthProductSpecimenListViewRoute: AuthProductSpecimenListViewRoute,
  AuthProductSpecimenRequisitionRoute: AuthProductSpecimenRequisitionRoute,
  AuthProductSpecimenRequisitionReviewRoute:
    AuthProductSpecimenRequisitionReviewRoute,
  AuthProductSpecimensRoute: AuthProductSpecimensRoute,
  AuthPromotionDistributionRoute: AuthPromotionDistributionRoute,
  AuthPromotionItemTypesRoute: AuthPromotionItemTypesRoute,
  AuthPromotionItemsRoute: AuthPromotionItemsRoute,
  AuthPublishAccountsRoute: AuthPublishAccountsRoute,
  AuthPublishMisRoute: AuthPublishMisRoute,
  AuthPublishSalesRoute: AuthPublishSalesRoute,
  AuthQuestionDownloadRoute: AuthQuestionDownloadRoute,
  AuthQuestionDownloadByBoardRoute: AuthQuestionDownloadByBoardRoute,
  AuthQuestionDownloadByClassRoute: AuthQuestionDownloadByClassRoute,
  AuthQuestionProjectsRoute: AuthQuestionProjectsRoute,
  AuthQuestionSubjectsRoute: AuthQuestionSubjectsRoute,
  AuthQuestionUploadRoute: AuthQuestionUploadRoute,
  AuthReportsAppVersionCheckRoute: AuthReportsAppVersionCheckRoute,
  AuthSettingsFeedbackTypesRoute: AuthSettingsFeedbackTypesRoute,
  AuthSettingsHolidaysRoute: AuthSettingsHolidaysRoute,
  AuthSettingsInstituteTypesRoute: AuthSettingsInstituteTypesRoute,
  AuthSettingsLeaveTypesRoute: AuthSettingsLeaveTypesRoute,
  AuthSettingsLimitTypesRoute: AuthSettingsLimitTypesRoute,
  AuthSettingsMenuLabelsRoute: AuthSettingsMenuLabelsRoute,
  AuthSettingsWebUrlsRoute: AuthSettingsWebUrlsRoute,
  AuthUsersAdminRoute: AuthUsersAdminRoute,
  AuthUsersAgentRoute: AuthUsersAgentRoute,
  AuthUsersEditRoute: AuthUsersEditRoute,
  AuthUsersGeneralRoute: AuthUsersGeneralRoute,
  AuthUsersMarketingRoute: AuthUsersMarketingRoute,
  AuthUsersPermissionsRoute: AuthUsersPermissionsRoute,
  AuthUsersRolesRoute: AuthUsersRolesRoute,
  AuthUsersSpecialRoute: AuthUsersSpecialRoute,
  AuthUsersViewRoute: AuthUsersViewRoute,
  AuthAttendanceIndexRoute: AuthAttendanceIndexRoute,
  AuthUsersIndexRoute: AuthUsersIndexRoute,
  AuthDashboardsDcrUserIdRoute: AuthDashboardsDcrUserIdRoute,
  AuthDashboardsSystemUserIdRoute: AuthDashboardsSystemUserIdRoute,
  AuthFeedbackListFeedbackIdRoute: AuthFeedbackListFeedbackIdRoute,
  AuthFeedbackSurveysNewRoute: AuthFeedbackSurveysNewRoute,
  AuthGeoLocationMoTravelHistoryUserIdRoute:
    AuthGeoLocationMoTravelHistoryUserIdRoute,
  AuthHrFormLeaveApplicationsApplicationIdRoute:
    AuthHrFormLeaveApplicationsApplicationIdRoute,
  AuthMarketPromotionApprovalsDetailIdRoute:
    AuthMarketPromotionApprovalsDetailIdRoute,
  AuthMarketPromotionPublishPanelNewRoute:
    AuthMarketPromotionPublishPanelNewRoute,
  AuthMarketPromotionRegionSummaryDonationsRoute:
    AuthMarketPromotionRegionSummaryDonationsRoute,
  AuthPcmpProjectsNewRoute: AuthPcmpProjectsNewRoute,
  AuthProductBooklistedInstitutionProjectIdRoute:
    AuthProductBooklistedInstitutionProjectIdRoute,
  AuthProductStudentCollectionProjectsProjectIdRoute:
    AuthProductStudentCollectionProjectsProjectIdRoute,
  AuthPublishBatchesBatchIdRoute: AuthPublishBatchesBatchIdRoute,
  AuthQuestionMonitorClassesRoute: AuthQuestionMonitorClassesRoute,
  AuthQuestionMonitorDistrictsRoute: AuthQuestionMonitorDistrictsRoute,
  AuthQuestionPapersProjectInstituteIdRoute:
    AuthQuestionPapersProjectInstituteIdRoute,
  AuthSettingsInstituteSubmissionsSubmissionIdRoute:
    AuthSettingsInstituteSubmissionsSubmissionIdRoute,
  AuthSettingsInstitutesCreateRoute: AuthSettingsInstitutesCreateRoute,
  AuthSettingsInstitutesUserMappingRoute:
    AuthSettingsInstitutesUserMappingRoute,
  AuthSettingsTeacherInactivationsRequestIdRoute:
    AuthSettingsTeacherInactivationsRequestIdRoute,
  AuthSettingsTeacherSubmissionsTeacherIdRoute:
    AuthSettingsTeacherSubmissionsTeacherIdRoute,
  AuthUsersCreateCategoryRoute: AuthUsersCreateCategoryRoute,
  AuthDashboardsDcrIndexRoute: AuthDashboardsDcrIndexRoute,
  AuthDashboardsSystemIndexRoute: AuthDashboardsSystemIndexRoute,
  AuthDashboardsZonalStatementIndexRoute:
    AuthDashboardsZonalStatementIndexRoute,
  AuthFeedbackListIndexRoute: AuthFeedbackListIndexRoute,
  AuthFeedbackSurveysIndexRoute: AuthFeedbackSurveysIndexRoute,
  AuthGeoLocationMoTravelHistoryIndexRoute:
    AuthGeoLocationMoTravelHistoryIndexRoute,
  AuthHrFormLeaveApplicationsIndexRoute: AuthHrFormLeaveApplicationsIndexRoute,
  AuthMarketPromotionAdjustmentIndexRoute:
    AuthMarketPromotionAdjustmentIndexRoute,
  AuthMarketPromotionApprovalsIndexRoute:
    AuthMarketPromotionApprovalsIndexRoute,
  AuthMarketPromotionPublishPanelIndexRoute:
    AuthMarketPromotionPublishPanelIndexRoute,
  AuthMarketPromotionRegionSummaryIndexRoute:
    AuthMarketPromotionRegionSummaryIndexRoute,
  AuthPcmpAccountsIndexRoute: AuthPcmpAccountsIndexRoute,
  AuthPcmpCorrectionIndexRoute: AuthPcmpCorrectionIndexRoute,
  AuthPcmpDepartmentDivisionsIndexRoute: AuthPcmpDepartmentDivisionsIndexRoute,
  AuthPcmpDisburseVerifyIndexRoute: AuthPcmpDisburseVerifyIndexRoute,
  AuthPcmpEditPermissionsIndexRoute: AuthPcmpEditPermissionsIndexRoute,
  AuthPcmpMarketingIndexRoute: AuthPcmpMarketingIndexRoute,
  AuthPcmpMisIndexRoute: AuthPcmpMisIndexRoute,
  AuthPcmpProjectsIndexRoute: AuthPcmpProjectsIndexRoute,
  AuthPcmpRequestCategoriesIndexRoute: AuthPcmpRequestCategoriesIndexRoute,
  AuthPcmpRequestsIndexRoute: AuthPcmpRequestsIndexRoute,
  AuthProductBooklistedInstitutionIndexRoute:
    AuthProductBooklistedInstitutionIndexRoute,
  AuthProductSpecimenDistributionIndexRoute:
    AuthProductSpecimenDistributionIndexRoute,
  AuthProductStudentCollectionProjectsIndexRoute:
    AuthProductStudentCollectionProjectsIndexRoute,
  AuthPromotionAdjustmentIndexRoute: AuthPromotionAdjustmentIndexRoute,
  AuthSettingsInstituteSubmissionsIndexRoute:
    AuthSettingsInstituteSubmissionsIndexRoute,
  AuthSettingsInstitutesIndexRoute: AuthSettingsInstitutesIndexRoute,
  AuthSettingsTeacherInactivationsIndexRoute:
    AuthSettingsTeacherInactivationsIndexRoute,
  AuthSettingsTeacherSubmissionsIndexRoute:
    AuthSettingsTeacherSubmissionsIndexRoute,
  AuthDashboardsZonalStatementUserIdExpenseRoute:
    AuthDashboardsZonalStatementUserIdExpenseRoute,
  AuthDashboardsZonalStatementUserIdSpecimenRoute:
    AuthDashboardsZonalStatementUserIdSpecimenRoute,
  AuthFeedbackSurveysSurveyIdEditRoute: AuthFeedbackSurveysSurveyIdEditRoute,
  AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute:
    AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute,
  AuthMarketPromotionPublishPanelBatchesBatchIdRoute:
    AuthMarketPromotionPublishPanelBatchesBatchIdRoute,
  AuthMarketPromotionPublishPanelZonalManagersUserIdRoute:
    AuthMarketPromotionPublishPanelZonalManagersUserIdRoute,
  AuthPcmpProjectsProjectIdCreatedRoute: AuthPcmpProjectsProjectIdCreatedRoute,
  AuthPcmpProjectsProjectIdEditRoute: AuthPcmpProjectsProjectIdEditRoute,
  AuthProductSpecimenDistributionSpecimenIdZmIdRoute:
    AuthProductSpecimenDistributionSpecimenIdZmIdRoute,
  AuthPromotionAdjustmentPromoItemIdZmIdRoute:
    AuthPromotionAdjustmentPromoItemIdZmIdRoute,
  AuthQuestionMonitorInstitutesProjectInstituteIdRoute:
    AuthQuestionMonitorInstitutesProjectInstituteIdRoute,
  AuthSettingsInstitutesInstituteIdEditRoute:
    AuthSettingsInstitutesInstituteIdEditRoute,
  AuthFeedbackSurveysSurveyIdIndexRoute: AuthFeedbackSurveysSurveyIdIndexRoute,
  AuthMarketPromotionAdjustmentPromoItemIdIndexRoute:
    AuthMarketPromotionAdjustmentPromoItemIdIndexRoute,
  AuthPcmpProjectsProjectIdIndexRoute: AuthPcmpProjectsProjectIdIndexRoute,
  AuthPcmpProposalsProposalIdIndexRoute: AuthPcmpProposalsProposalIdIndexRoute,
  AuthPcmpReportsMisStatusIndexRoute: AuthPcmpReportsMisStatusIndexRoute,
  AuthPcmpReportsMoWiseIndexRoute: AuthPcmpReportsMoWiseIndexRoute,
  AuthPcmpReportsPendingIndexRoute: AuthPcmpReportsPendingIndexRoute,
  AuthPcmpReportsPerformanceIndexRoute: AuthPcmpReportsPerformanceIndexRoute,
  AuthPcmpRequestsRequestedIndexRoute: AuthPcmpRequestsRequestedIndexRoute,
  AuthProductSpecimenDistributionSpecimenIdIndexRoute:
    AuthProductSpecimenDistributionSpecimenIdIndexRoute,
  AuthPromotionAdjustmentPromoItemIdIndexRoute:
    AuthPromotionAdjustmentPromoItemIdIndexRoute,
  AuthQuestionMonitorInstitutesIndexRoute:
    AuthQuestionMonitorInstitutesIndexRoute,
  AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRoute:
    AuthFeedbackSurveysSurveyIdSubmissionsSubmissionIdRoute,
  AuthFeedbackSurveysSurveyIdSubmissionsIndexRoute:
    AuthFeedbackSurveysSurveyIdSubmissionsIndexRoute,
  AuthPcmpAccountsBatchesBatchNoIndexRoute:
    AuthPcmpAccountsBatchesBatchNoIndexRoute,
  AuthPcmpAccountsRedisburseBatchesBatchNoIndexRoute:
    AuthPcmpAccountsRedisburseBatchesBatchNoIndexRoute,
  AuthPcmpMarketingBatchesBatchNoIndexRoute:
    AuthPcmpMarketingBatchesBatchNoIndexRoute,
  AuthPcmpMisBatchesBatchNoIndexRoute: AuthPcmpMisBatchesBatchNoIndexRoute,
  AuthPcmpRequestsBatchesBatchNoIndexRoute:
    AuthPcmpRequestsBatchesBatchNoIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PrintRouteChildren {
  PrintPcmpProposalsProposalIdPrintRoute: typeof PrintPcmpProposalsProposalIdPrintRoute
  PrintPcmpReportsMisStatusPrintRoute: typeof PrintPcmpReportsMisStatusPrintRoute
  PrintPcmpReportsMoWisePrintRoute: typeof PrintPcmpReportsMoWisePrintRoute
  PrintPcmpReportsPendingPrintRoute: typeof PrintPcmpReportsPendingPrintRoute
  PrintPcmpReportsPerformancePrintRoute: typeof PrintPcmpReportsPerformancePrintRoute
  PrintPcmpAccountsBatchesBatchNoPrintRoute: typeof PrintPcmpAccountsBatchesBatchNoPrintRoute
  PrintPcmpAccountsRedisburseBatchesBatchNoPrintRoute: typeof PrintPcmpAccountsRedisburseBatchesBatchNoPrintRoute
  PrintPcmpMisBatchesBatchNoPrintRoute: typeof PrintPcmpMisBatchesBatchNoPrintRoute
  PrintPcmpRequestsBatchesBatchNoPrintRoute: typeof PrintPcmpRequestsBatchesBatchNoPrintRoute
}

const PrintRouteChildren: PrintRouteChildren = {
  PrintPcmpProposalsProposalIdPrintRoute:
    PrintPcmpProposalsProposalIdPrintRoute,
  PrintPcmpReportsMisStatusPrintRoute: PrintPcmpReportsMisStatusPrintRoute,
  PrintPcmpReportsMoWisePrintRoute: PrintPcmpReportsMoWisePrintRoute,
  PrintPcmpReportsPendingPrintRoute: PrintPcmpReportsPendingPrintRoute,
  PrintPcmpReportsPerformancePrintRoute: PrintPcmpReportsPerformancePrintRoute,
  PrintPcmpAccountsBatchesBatchNoPrintRoute:
    PrintPcmpAccountsBatchesBatchNoPrintRoute,
  PrintPcmpAccountsRedisburseBatchesBatchNoPrintRoute:
    PrintPcmpAccountsRedisburseBatchesBatchNoPrintRoute,
  PrintPcmpMisBatchesBatchNoPrintRoute: PrintPcmpMisBatchesBatchNoPrintRoute,
  PrintPcmpRequestsBatchesBatchNoPrintRoute:
    PrintPcmpRequestsBatchesBatchNoPrintRoute,
}

const PrintRouteWithChildren = PrintRoute._addFileChildren(PrintRouteChildren)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PrintRoute: PrintRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  SsoRoute: SsoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
